import * as React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DatePicker as SitDatePicker } from 'Src/components/DatePicker/DatePicker';
import BPromise from 'bluebird';
import Lazy from 'lazy.js';
import propz from 'propz';
import moment from 'moment';
import { parse } from 'query-string';
import { AppUser } from 'Src/views/App/App';
import {
  ColumnDefinition,
  getFilters2,
  getOrder,
  getPagesCount,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, LIMIT } from 'Src/consts/table';
import { Loader } from 'Src/components/Loader/Loader';
import { ListEmptyState } from 'Src/components/ListEmptyState/ListEmptyState';
import { faRunning } from '@fortawesome/free-solid-svg-icons';
import { SelectAllCheckbox } from 'Src/components/SelectAllCheckbox/SelectAllCheckbox';
import { getAllForms } from 'Src/helpers/service/admin/forms';
import { sortAges } from 'Src/helpers/event/event';
import {
  getClubAcademicYear,
  getClubAges,
  getAgesGroupFormatted,
  getClubCoaches,
  getClubGender,
  getClubMembersOfStaff,
  getClubRecurrence,
  getClubStartDate,
  getClubStartTime,
  getClubStatus,
  getClubWeekDays
} from 'Src/helpers/accessor/accessor';
import { History, Location } from 'history';
import { Grid2 } from 'Src/components/Grid/Grid2';
import { Club, ClubParticipantsExtended } from 'Src/models/club';
import {
  activateClub,
  activateClubWithOccurrences,
  getClubActivatePreview,
  getClub,
  deleteClub,
  getAllClubs,
  getClubs,
  getClubsCount,
  updateClub,
  getClubArchivePreview,
  archiveClub,
  restoreClubAsDraft,
  ClubArchivePreview
} from 'Src/helpers/service/admin/clubs';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { SendRequestPageShell } from 'Src/components/SendRequestPageShell/SendRequestPageShell';
import { ClubActivateSummary } from './ClubActivateSummary/ClubActivateSummary';
import {
  CLUB_INVITATIONS,
  CLUB_INVITATIONS_SERVER_TO_CLIENT_MAPPING,
  CLUB_MESSAGE_INVITE_STATUS_ALL,
  CLUB_STATUS,
  CLUB_TABS_ARRAY,
  CLUB_TABS,
  CLUB_PRICING,
  CLUB_TABS_FOR_SCHOOL_WITHOUT_PAYMENT
} from 'Src/consts/club';
import {
  getClubMessagesCount,
  sendClubMessages,
  SendClubMessagesPayload
} from 'Src/helpers/service/admin/clubMessages';
import {
  getClubConfirmationRequestTemplate,
  getClubStudentsCount,
  getClubStudentsCountPost
} from 'Src/helpers/service/admin/clubStudents';
import {
  getSelectOptionForAge,
  getSelectOptionForClubAcademicYears,
  getSelectOptionForClubGender,
  getSelectOptionForClubRecurrence,
  getSelectOptionForClubStatus,
  getSelectOptionForClubWeekDays
} from 'Src/helpers/table/select';
import { Button } from 'Src/components/Button/Button';
import { GenericSummary } from 'Src/components/GenericSummary/GenericSummary';
import { ClubSummary } from './ClubSummary/ClubSummary';
import { ClubParticipantsSummary } from './ClubParticipantsSummary/ClubParticipantsSummary';
import { getAllClubParticipants, getClubEvents, getClubPayments } from 'Src/helpers/service/admin/clubParticipants';
import { getClubEventsCount } from 'Src/helpers/service/admin/clubEvents';
import { EVENT_STATUS } from 'Src/consts/event';
import './Clubs.css';
import 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/SchoolEventView.scss';
import 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventReports.scss';
import { ClubPaymentsSummary } from './ClubPaymentsSummary/ClubPaymentsSummary';
import { Transaction } from 'Src/models/transaction';
import { getClubInvitations } from 'Src/helpers/club/club';
import { ConfirmationRequestTemplate } from 'Src/models/confirmationRequestTemplate';
import { FormDefinition } from 'Src/types/formSchema';
import {
  ConfirmationRequestForm,
  ConfirmationRequestFormField
} from 'Src/components/ConfirmationRequestForm/ConfirmationRequestForm';
import { INPUT_MASK_VALIDATION, WEEK_DAYS_SHORT_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/date';
import { sortPlayersByLastNameAsc } from 'Src/helpers/players/players';
import { uploadReport } from 'Src/helpers/service/admin/report';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { MODE_TYPE } from '../../../../../consts/common';
import { AGE_GROUPS, AGE_GROUPS_SORTED } from '../../../../../consts/school';
import { ClubPaymentSettingsSummary } from './ClubPaymentSettingsSummary/ClubPaymentSettingsSummary';
import { SchoolForm } from 'Src/models/form';
import MaskedInput from 'react-text-mask';
import { INVITE_KIND } from 'Src/consts/invite';
import { INVITE_KIND_TYPE } from 'Src/types/invite';
import { AggregateClubParticipationReportForm } from './Reports/AggregateClubParticipationReportForm/AggregateClubParticipationReportForm';
import { ClubAttendanceReportForm } from './Reports/ClubAttendanceReportForm/ClubAttendanceReportForm';
import { ParticipationsByClubsReportForm } from './Reports/ParticipationsByClubsReportForm/ParticipationsByClubsReportForm';
import { ClubParticipationByStudentsReportForm } from './Reports/ClubParticipationByStudentsReportForm/ClubParticipationByStudentsReportForm';
import { ClubListByStudentsReportForm } from './Reports/ClubListByStudentsReportForm/ClubListByStudentsReportForm';
import { ClubAttendanceByStudentsReportForm } from './Reports/ClubAttendanceByStudentsReportForm/ClubAttendanceByStudentsReportForm';
import { ParticipationsByClubsYearGroupsReportForm } from './Reports/ParticipationsByClubsYearGroupsReportForm/ParticipationsByClubsYearGroupsReportForm';
import { ClubBookingsReportForm } from './Reports/ClubBookingsReportForm/ClubBookingsReportForm';
import { SelectedClubParticipationByStudentsReportForm } from './Reports/SelectedClubParticipationByStudentsReportForm/SelectedClubParticipationByStudentsReportForm';
import { DateClubsReportForm } from './Reports/DateClubsReportForm/DateClubsReportForm';
import { ClubParticipationByClubNumberReportForm } from './Reports/ClubParticipationByClubNumberReportForm/ClubParticipationByClubNumberReportForm';
import { WeeklyClubScheduleReportForm } from './Reports/WeeklyClubScheduleReportForm/WeeklyClubScheduleReportForm';
import { AverageClubAttendanceReportForm } from './Reports/AverageClubAttendanceReportForm/AverageClubAttendanceReportForm';
import { PaperAttendanceRegisterClubReportForm } from './Reports/PaperAttendanceRegisterClubReportForm/PaperAttendanceRegisterClubReportForm';
import { isUserTeacher, isUserCoach } from 'Src/helpers/user/user';
import { ClubInvitationRecipientsStep } from './ClubInvitationRecipientsStep';

const SEND_CLUB_INVITATIONS_QUERY_PARAM = 'sendClubInvitations';
import { isThisWeek } from 'date-fns';

export const DEFAULT_CLUB_TABLE_FILTERS = `status=${CLUB_STATUS.ACTIVE}&status=${CLUB_STATUS.DRAFT}`;

const DEFAULT_CLUB_SEARCH = {
  status: [CLUB_STATUS.ACTIVE, CLUB_STATUS.DRAFT]
};

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Name',
    field: 'name',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['name']
  },
  {
    text: 'Academic year',
    field: 'clubAcademicYear',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getClubAcademicYear
  },
  {
    text: 'Start date',
    field: 'clubStartDate',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: getClubStartDate
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: true,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getClubGender
  },
  {
    text: 'Ages',
    field: 'clubAges',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getAgesGroupFormatted
  },
  {
    text: 'Leader/Coach',
    field: 'clubCoaches',
    isSort: false,
    type: FILTER_TYPE.TEXT,
    accessor: getClubCoaches
  },
  {
    text: 'Member of staff',
    field: 'clubMembersOfStaff',
    isSort: false,
    type: FILTER_TYPE.TEXT,
    accessor: getClubMembersOfStaff
  },
  {
    text: 'Week days',
    field: 'clubWeekDays',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getClubWeekDays
  },
  {
    text: 'Recurrence',
    field: 'clubRecurrence',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getClubRecurrence
  },
  {
    text: 'Start time',
    field: 'clubStartTime',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getClubStartTime
  },
  {
    text: 'Status',
    field: 'status',
    isSort: true,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getClubStatus
  }
];

interface ClubDsColumn {
  field: string;
  text: string;
  isSort?: boolean;
  locked?: boolean;
  render: (club: Club) => React.ReactNode;
}

interface State {
  items: Club[];
  currentPage: number;
  selectedItems: Club[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  filters: any;
  isDataFiltered: boolean;
  isLoading: boolean;
  totalWithFilters: number;
  total: number;
  basePath: string;
  isSelectAllChecked: boolean;
  isDeleteClubModalOpen: boolean;
  currentTabIndex: number;
  clubParticipants: ClubParticipantsExtended[];
  isClubParticipantsLoading: boolean;
  isClubEventsLoading: boolean;
  clubEventSummary: {
    total: number;
    upcoming: number;
    past: number;
    cancelled: number;
  };
  clubInvitationSummary: {
    eligible: number;
    sent: number;
    accepted: number;
    rejected: number;
    pending: number;
    notSent: number;
  };
  isClubInvitationSummaryLoading: boolean;
  clubEvents: any[];
  forms: SchoolForm[];
  isActivateClubModalOpen: boolean;
  isSendInvitationsModalOpen: boolean;
  allClubsStudents: any[];
  clubPayments: Transaction[];
  isErrorInPayments: boolean;
  errorMessageInPayments: string;
  confirmationRequestTemplate?: ConfirmationRequestTemplate;
  isConfirmationRequestTemplateModalOpen: boolean;
  fields: ConfirmationRequestFormField[];
  selectedFormDefinition?: FormDefinition;
  deadlineForAnswers: string;
  deadlineForAnswersDate: Date | null;
  isDeadlineForAnswersError: boolean;
  invitationFlowStep: 'RECIPIENTS' | 'MULTI_WARNING' | 'FORM';
  invitationRecipients: any[];
  invitationUseAllEligible: boolean;
  invitationRecipientCount: number;
  isInvitationExitConfirmOpen: boolean;
  isInvitationSuccessModalOpen: boolean;
  successfulInvitationsCount: number;
  successfulClubsCount: number;

  isAggregateClubParticipationReportModalOpen: boolean;
  isClubAttendanceReportModalOpen: boolean;
  isParticipationByClubsReportModalOpen: boolean;
  isClubParticipationByStudentsReportModalOpen: boolean;
  isSelectedClubParticipationByStudentsReportModalOpen: boolean;
  isClubListByStudentsReportModalOpen: boolean;
  isClubAttendanceByStudentsReportModalOpen: boolean;
  isParticipationsByClubsYearGroupsReportModalOpen: boolean;
  isClubBookingsReportModalOpen: boolean;
  isWeeklyClubScheduleReportModalOpen: boolean;
  isDateClubsReportModalOpen: boolean;
  isClubParticipationByCLubNumberReportModalOpen: boolean;
  isAverageClubAttendanceReportModalOpen: boolean;
  isPaperAttendanceRegisterClubReportModalOpen: boolean;
  isReportsSelectionModalOpen: boolean;

  errorMessage: string;
  isErrorModalOpen: boolean;
  isArchiveClubsModalOpen: boolean;
  upcomingEventsExists: ClubArchivePreview[];
  isCreateClubsDisabledModalOpen: boolean;
  previewItem?: Club;
  hiddenClubColumnKeys: string[];
  isColumnsMenuOpen: boolean;

  activatePreviewStartTimes: string[];
  activateSelectedStartTimes: string[];
  isActivatePreviewLoading: boolean;
  activateSearchDay: string;
}

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

export class Clubs extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      filters: {},
      isDataFiltered: false,
      isLoading: false,
      totalWithFilters: 0,
      total: 0,
      basePath: '',
      isSelectAllChecked: false,
      isDeleteClubModalOpen: false,
      currentTabIndex: 0,
      clubParticipants: [],
      isClubParticipantsLoading: false,
      isClubEventsLoading: false,
      clubEventSummary: { total: 0, upcoming: 0, past: 0, cancelled: 0 },
      clubInvitationSummary: { eligible: 0, sent: 0, accepted: 0, rejected: 0, pending: 0, notSent: 0 },
      isClubInvitationSummaryLoading: false,
      clubEvents: [],
      isActivateClubModalOpen: false,
      isSendInvitationsModalOpen: false,
      allClubsStudents: [],
      forms: [],
      clubPayments: [],
      isErrorInPayments: false,
      errorMessageInPayments: '',
      confirmationRequestTemplate: undefined,
      isConfirmationRequestTemplateModalOpen: false,
      deadlineForAnswers: '',
      deadlineForAnswersDate: null,
      isDeadlineForAnswersError: false,
      invitationFlowStep: 'FORM',
      invitationRecipients: [],
      invitationUseAllEligible: false,
      invitationRecipientCount: 0,
      isInvitationExitConfirmOpen: false,
      isInvitationSuccessModalOpen: false,
      successfulInvitationsCount: 0,
      successfulClubsCount: 0,
      fields: [],
      selectedFormDefinition: undefined,

      isAggregateClubParticipationReportModalOpen: false,
      isClubAttendanceReportModalOpen: false,
      isParticipationByClubsReportModalOpen: false,
      isClubParticipationByStudentsReportModalOpen: false,
      isSelectedClubParticipationByStudentsReportModalOpen: false,
      isClubListByStudentsReportModalOpen: false,
      isClubAttendanceByStudentsReportModalOpen: false,
      isParticipationsByClubsYearGroupsReportModalOpen: false,
      isClubBookingsReportModalOpen: false,
      isWeeklyClubScheduleReportModalOpen: false,
      isDateClubsReportModalOpen: false,
      isClubParticipationByCLubNumberReportModalOpen: false,
      isAverageClubAttendanceReportModalOpen: false,
      isPaperAttendanceRegisterClubReportModalOpen: false,
      isReportsSelectionModalOpen: false,

      errorMessage: '',
      isErrorModalOpen: false,
      isArchiveClubsModalOpen: false,
      upcomingEventsExists: [] as ClubArchivePreview[],
      isCreateClubsDisabledModalOpen: false,
      previewItem: undefined,
      hiddenClubColumnKeys: this.getInitialClubColumnKeys(),
      isColumnsMenuOpen: false,

      activatePreviewStartTimes: [],
      activateSelectedStartTimes: [],
      isActivatePreviewLoading: false,
      activateSearchDay: ''
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.onClubDocumentMouseDown);
    document.addEventListener('keydown', this.onClubDocumentKeyDown);
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb', { detail: 'Clubs / Clubs' }));

    this.setState({ isLoading: true });

    const invitationClubId = this.getSendClubInvitationsClubId();
    if (this.isSendClubInvitationsPageOpen() && invitationClubId) {
      this.restoreSendClubInvitationsFlow(invitationClubId);
      return;
    }

    this.setAdditionalItems().then(res => {
      this.setItems();
    });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onClubDocumentMouseDown);
    document.removeEventListener('keydown', this.onClubDocumentKeyDown);
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb-clear'));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      const nextIsInvitationFlow =
        new URLSearchParams(nextProps.location.search).get(SEND_CLUB_INVITATIONS_QUERY_PARAM) === '1';
      if (nextIsInvitationFlow) return;

      this.setState({
        isLoading: true
      });
      this.setItems(nextProps.location);
    }
  }
  setAdditionalItems() {
    const { user } = this.props;

    return getAllForms(user).then(forms => {
      this.setState({
        forms
      });
    });
  }

  setItems(locationOverride?: Location) {
    const { history, user } = this.props;
    const location = locationOverride || this.props.location;

    const userId = propz.get(user, ['userId']);

    const isUserTeacherOrCoach = isUserTeacher(user) || isUserCoach(user);

    const isCoachHasAccessOnlyToAffectedEvents = propz.get(user, ['activeSchool', 'isCoachSeenOnlyAffectedEvents']);
    const isTeacherHasAccessOnlyToAffectedEvents = propz.get(user, ['activeSchool', 'isTeacherSeenOnlyAffectedEvents']);

    const userPermissionSports = propz.get(user, ['activePermission', 'sports'], []);
    const userPermissionSportsIds = userPermissionSports.map(sport => sport.id);
    const isUserPermissionSportsExist = userPermissionSports.length > 0;

    const search = parse(location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(COLUMNS, search);
    const defaultFilters = getFilters2(COLUMNS, DEFAULT_CLUB_SEARCH);

    const isShowFilter = false;
    const isDataFiltered = isFilterExist2(filters);

    const where = getServerFieldSectionWhere(filters);
    const defaultWhere = getServerFieldSectionWhere(defaultFilters);

    if (isUserTeacherOrCoach && isUserPermissionSportsExist) {
      propz.set(where, ['sportId'], {
        $in: userPermissionSportsIds
      });

      propz.set(defaultWhere, ['sportId'], {
        $in: userPermissionSportsIds
      });
    }

    if (
      (isUserCoach(user) && isCoachHasAccessOnlyToAffectedEvents) ||
      (isUserTeacher(user) && isTeacherHasAccessOnlyToAffectedEvents)
    ) {
      propz.set(where, ['staff.userId'], {
        $in: [userId]
      });

      propz.set(defaultWhere, ['staff.userId'], {
        $in: [userId]
      });
    }

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);

    const getItemsPromise = getClubs(user, serverQueryFilter);
    const getItemsCountPromise = getClubsCount(user, where);
    const getItemsTotalCountPromise = getClubsCount(user, defaultWhere);

    const promises = [getItemsCountPromise, getItemsTotalCountPromise, getItemsPromise];

    const tabs = this.getTabs();
    const clubId = propz.get(location, ['state', 'clubId']);
    const currentTabIndex = propz.get(location, ['state', 'currentTabIndex'], 0);

    let totalWithFiltersObj;
    let totalObj;
    let items;

    return BPromise.all(promises)
      .then(([_totalWithFiltersObj, _totalObj, _items]) => {
        totalWithFiltersObj = _totalWithFiltersObj;
        totalObj = _totalObj;
        items = _items;
        /*
        if (tabs[currentTabIndex] === CLUB_TABS.PARTICIPANT) {
          return getAllClubParticipants(user, clubId);
        }
*/
      })
      .then(participants => {
        if (typeof clubId !== 'undefined') {
          const club = items.find(item => item.id === clubId);
          /*
          const isParticipantsExist = typeof participants !== 'undefined';
          const sortParticipants = isParticipantsExist ? [...participants].sort(sortPlayersByLastNameAsc) : [];
*/
          this.setState({
            currentPage: page,
            sortDirection: sortDirection,
            sortColumnsName: sortColumnsName,
            isShowFilter: isShowFilter,
            isDataFiltered: isDataFiltered,
            filters: filters,
            items: items,
            totalWithFilters: totalWithFiltersObj.count,
            total: totalObj.count,
            basePath: history.location.pathname,
            isLoading: false,
            selectedItems: typeof club !== 'undefined' ? [club] : [],
            currentTabIndex
            //          clubParticipants: sortParticipants
          });

          const state = { ...(history.location.state as any) };
          delete state.clubId;
          history.replace({ ...history.location, state });
        } else {
          this.setState({
            currentPage: page,
            sortDirection: sortDirection as TABLE_SORT_DIRECTION,
            sortColumnsName: sortColumnsName,
            isShowFilter: isShowFilter,
            isDataFiltered: isDataFiltered,
            filters: filters,
            items: items,
            totalWithFilters: totalWithFiltersObj.count,
            total: totalObj.count,
            basePath: history.location.pathname,
            currentTabIndex,
            isLoading: false
          });
        }
        return true;
      });
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onItemClick = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      selectedItems: selectedItemsUpdated,
      currentTabIndex: 0
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: nextSelectedItems,
      isSelectAllChecked: true
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters);

    getAllClubs(user, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const nextSelectedItems = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: nextSelectedItems,
        isSelectAllChecked: true,
        isLoading: false
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (filterField === 'forms') {
      nextFilters.ages = [];
    }

    if (filterField === 'ages') {
      nextFilters.forms = [];
    }

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false,
      filters: {}
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: ''
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    this.setState(prevState => ({
      isShowFilter: !prevState.isShowFilter,
      isColumnsMenuOpen: false
    }));
  };

  renderDeleteClubModal(): React.ReactNode {
    const { selectedItems, isDeleteClubModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isDeleteClubModalOpen}
        title={selectedItems.length === 1 ? 'Delete club?' : `Delete ${selectedItems.length} clubs?`}
        buttonText={selectedItems.length === 1 ? 'Delete club' : 'Delete clubs'}
        buttonCancelText="Cancel"
        onButtonClick={this.onDeleteClubClick}
        onCloseClick={this.deleteClubModalClose}
        customClass="clubsModal clubsDeleteModal"
        dialogStyle={{ maxWidth: 500 }}
        isBodyBold={false}
      >
        <div className="clubsDeleteModal__body">
          <div className="clubsDeleteModal__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M12 8v5" />
              <path d="M12 17h.01" />
              <path d="M10.3 3.9 2.4 17.6A2 2 0 0 0 4.1 20h15.8a2 2 0 0 0 1.7-2.4L13.7 3.9a2 2 0 0 0-3.4 0Z" />
            </svg>
          </div>
          <div className="clubsDeleteModal__copy">
            <strong>
              {selectedItems.length === 1 ? selectedItems[0].name : `${selectedItems.length} selected clubs`}
            </strong>
            <p>
              {selectedItems.length === 1
                ? 'This club will be permanently removed. This action cannot be undone.'
                : 'The selected clubs will be permanently removed. This action cannot be undone.'}
            </p>
          </div>
        </div>
      </SimpleModal>
    );
  }

  onDeleteClubClick = () => {
    const { selectedItems } = this.state;
    const user = this.props.user;
    const clubIdList = selectedItems.map(item => item.id);

    this.setState({
      isLoading: true
    });

    BPromise.all(clubIdList.map(clubId => deleteClub(user, clubId)))
      .then(res => {
        this.setState({
          isDeleteClubModalOpen: false,
          isSelectAllChecked: false,
          selectedItems: []
        });
        this.setItems();
      })
      .catch(error => {
        console.error('deleteClub error:', error);

        this.setState({
          isLoading: false,
          isDeleteClubModalOpen: false,
          isErrorModalOpen: true,
          errorMessage: this.getErrorText(error, 'Failed to delete club(s).')
        });
      });
  };

  deleteClubModalClose = (): void => {
    this.setState({
      isDeleteClubModalOpen: false
    });
  };

  getErrorText = (error: any, fallback: string): string => {
    return (
      propz.get(error, ['response', 'data', 'details', 'text']) ||
      propz.get(error, ['response', 'data', 'error']) ||
      propz.get(error, ['response', 'data', 'message']) ||
      propz.get(error, ['message']) ||
      fallback
    );
  };

  renderActivateClubModal(): React.ReactNode {
    const { selectedItems, isActivateClubModalOpen } = this.state;

    const isSingle = selectedItems.length === 1;

    const { activatePreviewStartTimes, activateSelectedStartTimes, isActivatePreviewLoading } = this.state;

    const error = selectedItems.some(club => {
      const { participants, maxParticipants } = club;
      const numberParticipants = Array.isArray(participants) ? participants.length : 0;
      const maxParticipantsEqualZero = maxParticipants === 0;

      return !maxParticipantsEqualZero && numberParticipants > maxParticipants;
    });

    const isNoOccurrencesSelected = isSingle && !error && activateSelectedStartTimes.length === 0;

    const rawSearch = (this.state.activateSearchDay || '').replace(/\D/g, '').slice(0, 2);

    const filteredStartTimes =
      rawSearch.length > 0
        ? activatePreviewStartTimes.filter(iso =>
            moment(iso)
              .format('DD')
              .includes(rawSearch)
          )
        : activatePreviewStartTimes;

    const selectedInFiltered = activateSelectedStartTimes.filter(iso => filteredStartTimes.includes(iso));

    return (
      <SimpleModal
        isOpen={isActivateClubModalOpen}
        title={selectedItems.length === 1 ? 'Activate club' : 'Activate clubs'}
        buttonText={error || isNoOccurrencesSelected ? undefined : 'Activate'}
        buttonCancelText="Cancel"
        onButtonClick={selectedItems.length > 1 ? this.onActivateClubsClick : this.onActivateOneClubClick}
        onCloseClick={this.activateClubModalClose}
        customClass="clubsModal clubsActivateModal"
        dialogStyle={{ maxWidth: 720 }}
        isBodyBold={false}
      >
        <div className="cActivateModal">
          <div className="cActivateModal__intro">
            <span className="cActivateModal__introIcon" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <path d="M8 5h8" />
                <path d="M9 3h6a1 1 0 0 1 1 1v3H8V4a1 1 0 0 1 1-1Z" />
                <path d="M6 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z" />
                <path d="m9 14 2 2 4-4" />
              </svg>
            </span>
            <div>
              <strong>{isSingle ? 'Review club activation' : `Review ${selectedItems.length} clubs`}</strong>
              <span>
                {isSingle
                  ? 'Check the club and choose which scheduled occurrences should be created.'
                  : 'Each selected club will be activated and its scheduled events will be created.'}
              </span>
            </div>
          </div>

          <div className="cActivateModal__sectionHead">
            <div>
              <strong>{isSingle ? 'Club details' : 'Selected clubs'}</strong>
              <span>Confirm participant capacity before activation.</span>
            </div>
            <span className="cActivateModal__sectionCount">{selectedItems.length}</span>
          </div>
          <div className="cActivateModal__summary">
            {selectedItems.map((club, idx) => {
              const numberParticipants = Array.isArray(club.participants) ? club.participants.length : 0;
              const unlimited = club.maxParticipants === 0;
              const maxParticipantsText = unlimited ? 'Unlimited' : `${club.maxParticipants}`;
              const spacesAvailableText = unlimited ? 'Unlimited' : `${club.maxParticipants - numberParticipants}`;

              return (
                <div key={club.id || idx} className="cActivateModal__summaryCard">
                  <div className="cActivateModal__clubName">{club.name}</div>
                  <div className="mActivateStats">
                    <div className="mActivateStatsRow">
                      <div className="mActivateStatsLabel">Max participants</div>
                      <div className="mActivateStatsValue">{maxParticipantsText}</div>
                    </div>

                    <div className="mActivateStatsRow">
                      <div className="mActivateStatsLabel">Participants</div>
                      <div className="mActivateStatsValue">{numberParticipants}</div>
                    </div>

                    <div className="mActivateStatsRow">
                      <div className="mActivateStatsLabel">Spaces available</div>
                      <div className="mActivateStatsValue">{spacesAvailableText}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className={`cActivateModal__note ${error ? 'isError' : ''}`}>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 11v5" />
              <path d="M12 8h.01" />
            </svg>
            <span>
              {error
                ? 'Participants exceed the configured capacity. Update the club settings before activation.'
                : 'Activation creates the club schedule and makes it visible in the relevant staff, parent and student calendars.'}
            </span>
          </div>
        </div>
        {isSingle && !error && (
          <div className="cActivateModal__occ">
            <div className="cActivateModal__occHeader">
              <div>
                <div className="cActivateModal__occTitle">Select occurrences</div>
                <div className="cActivateModal__occHint">
                  Choose all dates or only the occurrences you want to create now.
                </div>
              </div>

              <label className="cActivateModal__occSearch">
                <span>Find day</span>
                <input
                  value={this.state.activateSearchDay}
                  placeholder="DD"
                  aria-label="Find occurrence by day of month"
                  inputMode="numeric"
                  onChange={e => {
                    const v = (e.target.value || '').replace(/\D/g, '').slice(0, 2);
                    this.setState({ activateSearchDay: v });
                  }}
                />
              </label>
            </div>

            {isActivatePreviewLoading && <div className="cActivateModal__muted">Loading occurrences…</div>}

            {!isActivatePreviewLoading && activatePreviewStartTimes.length === 0 && (
              <div className="cActivateModal__empty">
                <div className="cActivateModal__emptyTitle">No occurrences found</div>
                <div className="cActivateModal__muted">Check club schedule settings (days/time/date range).</div>
              </div>
            )}

            {!isActivatePreviewLoading && activatePreviewStartTimes.length > 0 && (
              <>
                <div className="cActivateModal__actions">
                  <div className="cActivateModal__actionsLeft">
                    <button
                      type="button"
                      onClick={() => this.setState({ activateSelectedStartTimes: [...filteredStartTimes] })}
                    >
                      Select all
                    </button>
                    <button type="button" onClick={() => this.setState({ activateSelectedStartTimes: [] })}>
                      Clear
                    </button>
                  </div>
                  <div className="cActivateModal__count">
                    Selected: {selectedInFiltered.length} / {filteredStartTimes.length}
                    {rawSearch ? ` (filter: ${rawSearch})` : ''}
                  </div>
                </div>

                <div className="cActivateModal__list mActivateOccurrences">
                  {filteredStartTimes.map((iso, idx) => {
                    const checked = activateSelectedStartTimes.includes(iso);

                    return (
                      <label key={`${iso}-${idx}`} className={`cActivateModal__row ${checked ? 'isChecked' : ''}`}>
                        <input
                          className="mActivateOccurrences__checkbox"
                          type="checkbox"
                          checked={checked}
                          onChange={e => {
                            const next = e.target.checked
                              ? [...activateSelectedStartTimes, iso]
                              : activateSelectedStartTimes.filter(x => x !== iso);

                            this.setState({ activateSelectedStartTimes: next });
                          }}
                        />
                        <span className="cActivateModal__date">{moment(iso).format('ddd, DD MMM YYYY')}</span>
                        <span className="cActivateModal__time">{moment(iso).format('HH:mm')}</span>
                      </label>
                    );
                  })}
                </div>
              </>
            )}

            {isNoOccurrencesSelected && (
              <div className="cActivateModal__validation">Select at least one occurrence to activate this club.</div>
            )}
          </div>
        )}
      </SimpleModal>
    );
  }

  renderArchiveClubsModal(): React.ReactNode {
    const { selectedItems, isArchiveClubsModalOpen, upcomingEventsExists } = this.state;

    if (selectedItems.length !== upcomingEventsExists.length) {
      return null;
    }

    const clubSummaries = selectedItems.map((club, index) => ({
      id: club.id,
      name: club.name,
      hasUpcomingEvents: upcomingEventsExists[index].futureEvents.length > 0,
      eventCount: upcomingEventsExists[index].futureEvents.length,
      canArchive: upcomingEventsExists[index].canArchive,
      linkedProgrammes: upcomingEventsExists[index].linkedProgrammes,
      fingerprint: upcomingEventsExists[index].fingerprint
    }));
    const clubsWithEventsCount = clubSummaries.filter(club => club.hasUpcomingEvents).length;
    const blockedClubs = clubSummaries.filter(club => !club.canArchive);

    return (
      <SimpleModal
        isOpen={isArchiveClubsModalOpen}
        title={selectedItems.length === 1 ? 'Archive club?' : `Archive ${selectedItems.length} clubs?`}
        onCloseClick={this.archiveClubModalClose}
        showFooter={false}
        isBodyBold={false}
        customClass="clubsModal clubsArchiveModal"
        bodyClassName="clubsModalBody"
        dialogStyle={{ maxWidth: 560 }}
      >
        <div className="clubsModalContent">
          <div className="clubsModalLead isWarning">
            <span className="clubsModalLeadIcon" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <path d="M4 7h16" />
                <path d="M6 7v12h12V7" />
                <path d="M9 4h6l1 3H8l1-3Z" />
                <path d="M9.5 11h5" />
              </svg>
            </span>
            <div>
              <strong>
                {clubsWithEventsCount ? 'Future events will be removed' : 'The clubs will leave the active list'}
              </strong>
              <p>
                {clubsWithEventsCount
                  ? 'Archiving removes every upcoming event for the affected clubs. Historical records remain available.'
                  : 'Archived clubs remain available in history and can be restored later.'}
              </p>
            </div>
          </div>

          <div className="clubsArchiveList">
            {clubSummaries.map(club => (
              <div key={club.id}>
                <strong>{club.name}</strong>
                <span className={club.hasUpcomingEvents ? 'isWarning' : ''}>
                  {club.hasUpcomingEvents
                    ? `${club.eventCount} upcoming ${club.eventCount === 1 ? 'event' : 'events'}`
                    : 'No upcoming events'}
                </span>
                {club.linkedProgrammes.length > 0 && (
                  <span className="isWarning">
                    Remove from {club.linkedProgrammes.map(programme => programme.name).join(', ')} first
                  </span>
                )}
              </div>
            ))}
          </div>

          <div className="clubsModalActions">
            <button type="button" className="clubsModalButton isSecondary" onClick={this.archiveClubModalClose}>
              Cancel
            </button>
            <button
              type="button"
              className="clubsModalButton isPrimary"
              onClick={this.onArchiveClubsClick}
              disabled={blockedClubs.length > 0}
            >
              Archive {selectedItems.length === 1 ? 'club' : 'clubs'}
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  }

  onArchiveClubsClick = async (): Promise<void> => {
    const { user } = this.props;
    const { selectedItems, upcomingEventsExists } = this.state;

    this.setState({
      isLoading: true
    });

    const results = await BPromise.allSettled(
      selectedItems.map((club, index) => archiveClub(user, club.id, upcomingEventsExists[index].fingerprint))
    );

    const failedResult = results.find(result => result.isRejected());

    this.setState({
      isArchiveClubsModalOpen: false,
      isSelectAllChecked: false,
      selectedItems: [],
      isLoading: false,
      isErrorModalOpen: Boolean(failedResult),
      errorMessage: failedResult
        ? this.getErrorText(
            failedResult.reason(),
            'One or more clubs could not be archived. Review the club and try again.'
          )
        : ''
    });
    this.setItems();
  };

  onActivateClubsClick = (): void => {
    const { user } = this.props;
    const { selectedItems } = this.state;

    this.setState({
      isLoading: true
    });

    BPromise.all(
      selectedItems.map(club => {
        const clubId = club.id;
        return activateClub(user, clubId);
      })
    )
      .then(res => {
        this.setState({
          isActivateClubModalOpen: false,
          isSelectAllChecked: false,
          selectedItems: [],
          isLoading: false
        });

        this.setItems();
        window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb-clear'));
      })
      .catch(err => {
        console.error('activate clubs error:', err);

        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage: this.getErrorText(err, 'Failed to activate club(s).')
        });
      });
  };

  onActivateOneClubClick = (): void => {
    const { user } = this.props;
    const { selectedItems, activatePreviewStartTimes, activateSelectedStartTimes } = this.state;

    const club = selectedItems[0];
    const clubId = club.id;
    if (activateSelectedStartTimes.length === 0) {
      return;
    }

    this.setState({ isLoading: true });

    const preview = Array.isArray(activatePreviewStartTimes) ? activatePreviewStartTimes : [];
    const selected = Array.isArray(activateSelectedStartTimes) ? activateSelectedStartTimes : [];

    const isPreviewLoaded = preview.length > 0;
    const isSubsetSelection = isPreviewLoaded && selected.length > 0 && selected.length < preview.length;

    let clubUpdated: any;

    const activatePromise = isSubsetSelection
      ? activateClubWithOccurrences(user, clubId, selected)
      : activateClub(user, clubId);

    activatePromise
      .then(clubData => {
        clubUpdated = clubData.club;
        return getClubEvents(user, clubId);
      })
      .then(events => {
        this.setState({
          isActivateClubModalOpen: false,
          isSelectAllChecked: false,
          selectedItems: [clubUpdated],
          currentTabIndex: 2,
          clubEvents: events,
          isLoading: false
        });

        this.setItems();
      })
      .catch(err => {
        console.error('activate club error:', err);

        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage: this.getErrorText(err, 'Failed to activate club.')
        });
      });
  };

  activateClubModalClose = (): void => {
    this.setState({
      isActivateClubModalOpen: false,
      activatePreviewStartTimes: [],
      activateSelectedStartTimes: [],
      isActivatePreviewLoading: false
    });
  };

  archiveClubModalClose = (): void => {
    this.setState({
      isArchiveClubsModalOpen: false
    });
  };

  renderSendInvitationsClubModal() {
    const { user } = this.props;

    const {
      selectedItems,
      isSendInvitationsModalOpen,
      allClubsStudents,
      deadlineForAnswersDate,
      isDeadlineForAnswersError,
      invitationUseAllEligible,
      invitationRecipientCount
    } = this.state;

    const { activeSchool } = user;
    const { clubInvitations } = activeSchool;

    if (!isSendInvitationsModalOpen) {
      return null;
    }

    const isPaymentsEnabled = propz.get(user, ['activeSchool', 'isPaymentsEnabled'], false);

    const isAllClubsAskToPayFieldActive = selectedItems.every(item => {
      return propz.get(item, ['paymentSettings', 'askToPay'], false);
    });

    const clubInfoText = selectedItems.map((club, index) => {
      const { name } = club;
      const clubStudents = allClubsStudents[index] || [];
      const numberStudents = clubStudents.length;

      const invitations = getClubInvitations(clubInvitations, club);
      let contacts: any[] = [];
      let numberContacts = 0;

      switch (invitations) {
        case CLUB_INVITATIONS.STUDENT: {
          contacts = clubStudents.filter(student => {
            const messageStatus = propz.get(student, ['messageStatus']);
            const isMessageStatusPending = messageStatus === CLUB_MESSAGE_INVITE_STATUS_ALL.PENDING;
            const isMessageStatusNotSent = messageStatus === CLUB_MESSAGE_INVITE_STATUS_ALL.NOT_SENT;

            return typeof student.email !== 'undefined' && (isMessageStatusPending || isMessageStatusNotSent);
          });
          numberContacts = contacts.length;
          break;
        }

        case CLUB_INVITATIONS.PARENT: {
          contacts = clubStudents.filter(student => {
            const messageStatus = propz.get(student, ['messageStatus']);
            const isMessageStatusPending = messageStatus === CLUB_MESSAGE_INVITE_STATUS_ALL.PENDING;
            const isMessageStatusNotSent = messageStatus === CLUB_MESSAGE_INVITE_STATUS_ALL.NOT_SENT;

            return (
              Array.isArray(student.parents) &&
              student.parents.length > 0 &&
              (isMessageStatusPending || isMessageStatusNotSent)
            );
          });

          const parents = Lazy(contacts)
            .map(contact => contact.parents)
            .flatten()
            .toArray();

          numberContacts = parents.length;
          break;
        }
      }

      let recipientsText = '';
      switch (invitations) {
        case CLUB_INVITATIONS.PARENT:
          recipientsText = CLUB_INVITATIONS_SERVER_TO_CLIENT_MAPPING.PARENT;
          break;
        case CLUB_INVITATIONS.STUDENT:
          recipientsText = CLUB_INVITATIONS_SERVER_TO_CLIENT_MAPPING.STUDENT;
          break;
      }

      return (
        <div key={index} className="clubsInviteConfirm__club">
          <strong>{name}</strong>
          <dl>
            <div>
              <dt>Recipients</dt>
              <dd>
                {invitationUseAllEligible && invitationRecipientCount > 0
                  ? invitationRecipientCount
                  : invitationUseAllEligible
                  ? 'All eligible students'
                  : numberStudents}
              </dd>
            </div>
            {!invitationUseAllEligible && (
              <div>
                <dt>Contacts</dt>
                <dd>{numberContacts}</dd>
              </div>
            )}
            <div>
              <dt>Sent to</dt>
              <dd>{recipientsText}</dd>
            </div>
          </dl>
        </div>
      );
    });

    return (
      <SimpleModal
        isOpen={isSendInvitationsModalOpen}
        title="Review invitations"
        buttonText="Send invitations"
        onButtonClick={this.onSendInvitationsClick}
        onCloseClick={this.sendInvitationsModalClose}
        isBodyBold={false}
        customClass="clubsModal clubsInviteConfirmModal"
        dialogStyle={{ maxWidth: 640 }}
      >
        <div className="clubsInviteConfirm">
          <div className="clubsInviteConfirm__banner">
            <span aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="9" />
                <path d="M12 10v6M12 7h.01" />
              </svg>
            </span>
            <p>
              {invitationUseAllEligible
                ? 'A separate booking invitation will be sent for every selected club to all of its eligible students.'
                : 'Booking invitations will be sent only to the recipients selected in the previous step.'}
            </p>
          </div>
          <div className="clubsInviteConfirm__clubs">{clubInfoText}</div>
          <div className="clubsInviteConfirm__deadline">
            <span>Deadline for answers</span>
            <strong>
              {deadlineForAnswersDate ? moment(deadlineForAnswersDate).format('DD/MM/YYYY HH:mm') : 'No deadline'}
            </strong>
          </div>
          {isDeadlineForAnswersError && (
            <div className="clubsInviteConfirm__error">Please select a valid future date and time.</div>
          )}
          {isPaymentsEnabled && !isAllClubsAskToPayFieldActive && (
            <div className="clubsInviteConfirm__warning">
              Club cost is not specified, so recipients will book without making a payment.
            </div>
          )}
        </div>
      </SimpleModal>
    );
  }

  setDeadlineFromDate = (date: Date | null) => {
    this.setState({
      deadlineForAnswersDate: date,
      deadlineForAnswers: date ? moment(date).format(INPUT_MASK_VALIDATION) : '',
      isDeadlineForAnswersError: false
    });
  };

  onDeadlineChange = (date: Date | null) => {
    this.setDeadlineFromDate(date);
  };

  onDeadlineChangeRaw = (event: any) => {
    const raw = (event?.target?.value || '').trim();

    this.setState({ deadlineForAnswers: raw });

    if (!raw) {
      this.setState({ deadlineForAnswersDate: null, isDeadlineForAnswersError: false });
      return;
    }

    const m = moment(raw, INPUT_MASK_VALIDATION, true);

    if (!m.isValid()) {
      this.setState({ isDeadlineForAnswersError: true });
      return;
    }

    this.setState({
      deadlineForAnswersDate: m.toDate(),
      isDeadlineForAnswersError: !m.isAfter(moment())
    });
  };

  sendInvitationsModalClose = (): void => {
    this.setState({ isInvitationExitConfirmOpen: true });
  };

  onSendInvitationsClick = () => {
    const {
      allClubsStudents,
      selectedItems,
      deadlineForAnswersDate,
      deadlineForAnswers,
      fields,
      selectedFormDefinition
    } = this.state;
    const { invitationUseAllEligible } = this.state;
    const { user } = this.props;
    const { clubInvitations } = user.activeSchool;

    const raw = (deadlineForAnswers || '').trim();
    let deadlineForAnswersIso: string | null = null;

    if (deadlineForAnswersDate) {
      const m = moment(deadlineForAnswersDate);
      if (!m.isValid() || !m.isAfter(moment())) {
        this.setState({ isDeadlineForAnswersError: true });
        return;
      }
      deadlineForAnswersIso = m.toISOString();
    } else if (raw) {
      const m = moment(raw, INPUT_MASK_VALIDATION, true);
      if (!m.isValid() || !m.isAfter(moment())) {
        this.setState({ isDeadlineForAnswersError: true });
        return;
      }
      deadlineForAnswersIso = m.toDate().toISOString();
    } else {
      deadlineForAnswersIso = null;
    }

    this.setState({ isLoading: true, isDeadlineForAnswersError: false });

    const buildPreparedUsers = (clubStudents: any[], invitations: any) => {
      if (!Array.isArray(clubStudents) || clubStudents.length === 0) return [];

      switch (invitations) {
        case CLUB_INVITATIONS.STUDENT:
          return clubStudents
            .filter(student => {
              const messageStatus = propz.get(student, ['messageStatus']);
              const isPending = messageStatus === CLUB_MESSAGE_INVITE_STATUS_ALL.PENDING;
              const isNotSent = messageStatus === CLUB_MESSAGE_INVITE_STATUS_ALL.NOT_SENT;
              const email = propz.get(student, ['email']);
              return typeof email !== 'undefined' && (isPending || isNotSent);
            })
            .map(student => ({ userId: student.id, permissionId: student.permissionId }));

        case CLUB_INVITATIONS.PARENT:
          return Lazy(clubStudents)
            .filter(student => {
              const messageStatus = propz.get(student, ['messageStatus']);
              const isPending = messageStatus === CLUB_MESSAGE_INVITE_STATUS_ALL.PENDING;
              const isNotSent = messageStatus === CLUB_MESSAGE_INVITE_STATUS_ALL.NOT_SENT;
              const parents = propz.get(student, ['parents'], []);
              return Array.isArray(parents) && parents.length > 0 && (isPending || isNotSent);
            })
            .map(student => {
              const parents = propz.get(student, ['parents'], []);
              return parents.map(parent => ({
                userId: parent.userId,
                permissionId: parent.permissionId,
                childId: student.id
              }));
            })
            .flatten()
            .toArray();

        default:
          return [];
      }
    };

    return BPromise.all(
      selectedItems.map((club, index) => {
        const clubId = club.id;
        const clubStudents = allClubsStudents[index] || [];
        const invitations = getClubInvitations(clubInvitations, club);

        const participants = buildPreparedUsers(clubStudents, invitations);

        const data: SendClubMessagesPayload = invitationUseAllEligible
          ? {
              selectAll: true,
              where: { participant: false },
              exclude: [],
              fields,
              ...(selectedFormDefinition
                ? { formSchemaVersion: 2 as const, formDefinition: selectedFormDefinition }
                : {}),
              deadlineForAnswers: deadlineForAnswersIso
            }
          : {
              participants,
              fields,
              ...(selectedFormDefinition
                ? { formSchemaVersion: 2 as const, formDefinition: selectedFormDefinition }
                : {}),
              deadlineForAnswers: deadlineForAnswersIso
            };

        return sendClubMessages(user, clubId, data);
      })
    )
      .then(results => {
        const successfulInvitationsCount = (results || []).reduce(
          (count, result) => count + (Array.isArray(result) ? result.length : 0),
          0
        );
        this.setState({
          isLoading: false,
          isSendInvitationsModalOpen: false,
          isInvitationExitConfirmOpen: false,
          isInvitationSuccessModalOpen: true,
          successfulInvitationsCount,
          successfulClubsCount: selectedItems.length,
          allClubsStudents: [],
          isSelectAllChecked: false,
          deadlineForAnswers: '',
          deadlineForAnswersDate: null,
          isDeadlineForAnswersError: false,
          invitationRecipients: [],
          invitationUseAllEligible: false,
          invitationRecipientCount: 0
        });

        this.setItems();
      })
      .catch(error => {
        console.error('sendClubMessages error:', error);

        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage: this.getErrorText(error, 'Failed to send invitations.')
        });
      });
  };

  isActivateClubAndSendInvitationsActive(): boolean {
    const { selectedItems, confirmationRequestTemplate } = this.state;
    const isAlSelectedClubStatusDraft = selectedItems.every(club => club.status === CLUB_STATUS.DRAFT);

    return selectedItems.length > 0 && isAlSelectedClubStatusDraft;
  }

  isDeleteClubStatusDraft(): boolean {
    const { selectedItems } = this.state;
    const isAlSelectedClubStatusDraft = selectedItems.every(club => club.status === CLUB_STATUS.DRAFT);

    return selectedItems.length > 0 && isAlSelectedClubStatusDraft;
  }

  onCreateClubClick = () => {
    const { user } = this.props;
    const isClubsEnabled = propz.get(user, ['activeSchool', 'isClubsEnabled']);

    isClubsEnabled ? this.onCreateClubWithWizardClick() : this.openCreateClubsDisabledModal();
  };

  onCreateClubWithWizardClick = (): void => {
    const { history } = this.props;
    const search = propz.get(history, ['location', 'search'], '');

    const { basePath, total } = this.state;
    const lastClubPage = getPagesCount(total + 1, LIMIT);

    history.push({
      pathname: `${basePath}/wizard`,
      state: {
        lastClubPage,
        search
      }
    });
  };

  renderCreateClubsDisabledModal(): React.ReactNode {
    const { isCreateClubsDisabledModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isCreateClubsDisabledModalOpen}
        title="Clubs are not included"
        onCloseClick={this.closeCreateClubsDisabledModal}
        showFooter={false}
        isBodyBold={false}
        customClass="clubsModal clubsInfoModal"
        bodyClassName="clubsModalBody"
        dialogStyle={{ maxWidth: 460 }}
      >
        <div className="clubsModalContent">
          <div className="clubsModalLead isInfo">
            <span className="clubsModalLeadIcon" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="8.5" />
                <path d="M12 10.5v5" />
                <path d="M12 7.5h.01" />
              </svg>
            </span>
            <div>
              <strong>This feature is unavailable on the current subscription</strong>
              <p>Contact the Squad In Touch support team if you would like to enable extracurricular clubs.</p>
            </div>
          </div>
          <div className="clubsModalActions">
            <button type="button" className="clubsModalButton isPrimary" onClick={this.closeCreateClubsDisabledModal}>
              OK
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  }

  openCreateClubsDisabledModal = () => {
    this.setState({
      isCreateClubsDisabledModalOpen: true
    });
  };

  closeCreateClubsDisabledModal = () => {
    this.setState({
      isCreateClubsDisabledModalOpen: false
    });
  };

  onRestoreClubClick = () => {
    const { user } = this.props;
    const { selectedItems } = this.state;
    const clubIds = selectedItems.map(club => club.id);

    const promises = clubIds.map(clubId => restoreClubAsDraft(user, clubId));

    this.setState({
      isLoading: true
    });

    BPromise.all(promises)
      .then(() => {
        this.setState({ isSelectAllChecked: false, selectedItems: [] });
        this.setItems();
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage: this.getErrorText(error, 'The club could not be restored as a draft.')
        });
      });
  };

  onArchiveClubClick = () => {
    const { user } = this.props;
    const { selectedItems } = this.state;
    const clubIds = selectedItems.map(club => club.id);

    const upcomingEventsPromises = clubIds.map(clubId => getClubArchivePreview(user, clubId));

    this.setState({
      isLoading: true
    });

    BPromise.all(upcomingEventsPromises)
      .then(upcomingEventsExists => {
        this.setState({ isLoading: false, upcomingEventsExists, isArchiveClubsModalOpen: true });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage: this.getErrorText(error, 'The archive impact could not be loaded.')
        });
      });
  };

  onCopyClubWithWizardClick = (modeType): void => {
    const { history } = this.props;
    const search = propz.get(history, ['location', 'search'], '');

    const { basePath, selectedItems, total } = this.state;
    const lastClubPage = getPagesCount(total + 1, LIMIT);
    const [club] = selectedItems;

    history.push({
      pathname: `${basePath}/wizard`,
      state: {
        lastClubPage,
        search
      },
      search: `club=${club.id}&mode=${modeType}`
    });
  };

  onEditClubWithWizardClick = (): void => {
    const { history } = this.props;
    const search = propz.get(history, ['location', 'search'], '');
    const { selectedItems, basePath } = this.state;
    const [club] = selectedItems;

    history.push({
      pathname: `${basePath}/wizard`,
      search: `club=${club.id}&mode=${MODE_TYPE.EDIT}`,
      state: {
        search
      }
    });
  };

  deleteClubModalOpen = (): void => {
    this.setState({
      isDeleteClubModalOpen: true
    });
  };

  activateClubModalOpen = (): void => {
    const { selectedItems } = this.state;

    this.setState({
      isActivateClubModalOpen: true,
      activatePreviewStartTimes: [],
      activateSelectedStartTimes: [],
      isActivatePreviewLoading: selectedItems.length === 1,
      activateSearchDay: ''
    });

    if (selectedItems.length === 1) {
      const { user } = this.props;
      const clubId = selectedItems[0].id;

      getClubActivatePreview(user, clubId)
        .then(preview => {
          const startTimes = Array.isArray(preview?.startTimes) ? preview.startTimes : [];
          this.setState({
            activatePreviewStartTimes: startTimes,
            activateSelectedStartTimes: startTimes,
            isActivatePreviewLoading: false
          });
        })
        .catch(err => {
          console.error('getClubActivatePreview error:', err);
          this.setState({
            activatePreviewStartTimes: [],
            activateSelectedStartTimes: [],
            isActivatePreviewLoading: false,
            isErrorModalOpen: true,
            errorMessage: this.getErrorText(err, 'Failed to load club activation preview.')
          });
        });
    }
  };

  isSendClubInvitationsPageOpen = (): boolean => {
    return new URLSearchParams(this.props.location.search).get(SEND_CLUB_INVITATIONS_QUERY_PARAM) === '1';
  };

  getSendClubInvitationsClubId = (search: string = this.props.location.search): string | undefined => {
    const clubId = new URLSearchParams(search).get('club');
    return clubId || undefined;
  };

  restoreSendClubInvitationsFlow = (clubId: string): void => {
    const { user, location } = this.props;

    Promise.all([getAllForms(user), getClub(user, clubId), getClubConfirmationRequestTemplate(user)])
      .then(([forms, club, confirmationRequestTemplate]) => {
        this.setState(
          {
            forms: forms || [],
            selectedItems: [club],
            basePath: location.pathname,
            confirmationRequestTemplate,
            invitationFlowStep: 'RECIPIENTS',
            invitationRecipients: [],
            invitationUseAllEligible: false,
            invitationRecipientCount: 0,
            isLoading: false
          },
          () => {
            window.dispatchEvent(
              new CustomEvent('sit:topbar-breadcrumb', { detail: `Clubs / ${club.name} / Send invitations` })
            );
            this.loadClubInvitationSummary(club, 'FLOW');
          }
        );
      })
      .catch(error => {
        this.closeSendClubInvitationsPage();
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage: this.getErrorText(error, 'Failed to restore the club invitation flow.')
        });
      });
  };

  openSendClubInvitationsPage = (): void => {
    const { history, location } = this.props;
    const { selectedItems } = this.state;
    const params = new URLSearchParams(location.search);
    if (selectedItems.length === 1) {
      params.set('club', selectedItems[0].id);
    } else {
      params.delete('club');
    }
    params.set(SEND_CLUB_INVITATIONS_QUERY_PARAM, '1');

    history.push({
      pathname: location.pathname,
      search: `?${params.toString()}`
    });
  };

  closeSendClubInvitationsPage = (): void => {
    const { history, location } = this.props;
    const params = new URLSearchParams(location.search);
    params.delete(SEND_CLUB_INVITATIONS_QUERY_PARAM);
    params.delete('club');
    const search = params.toString();

    history.push({
      pathname: location.pathname,
      search: search ? `?${search}` : ''
    });
  };

  isPaidClubSelection = (): boolean => {
    const { selectedItems } = this.state;
    const { activeSchool } = this.props.user;
    const { clubInvitations } = activeSchool;

    return selectedItems.reduce((result, item) => {
      const invitations = getClubInvitations(clubInvitations, item);
      const isStudentInvitation = invitations === CLUB_INVITATIONS.STUDENT;
      const isAskToPay = propz.get(item, ['paymentSettings', 'askToPay']);

      return result || (isStudentInvitation && isAskToPay);
    }, false);
  };
  sendInvitationsModalOpen = (): void => {
    const { selectedItems } = this.state;
    const { user } = this.props;

    this.setState({
      isLoading: true,
      clubInvitationSummary: { eligible: 0, sent: 0, accepted: 0, rejected: 0, pending: 0, notSent: 0 },
      isClubInvitationSummaryLoading: selectedItems.length === 1
    });

    if (selectedItems.length === 1) {
      this.loadClubInvitationSummary(selectedItems[0], 'FLOW');
    }

    getClubConfirmationRequestTemplate(user)
      .then(confirmationRequestTemplate => {
        const nextStep = selectedItems.length === 1 ? 'RECIPIENTS' : 'MULTI_WARNING';
        this.setState(
          {
            isLoading: false,
            confirmationRequestTemplate,
            isConfirmationRequestTemplateModalOpen: this.isPaidClubSelection(),
            invitationFlowStep: nextStep,
            invitationRecipients: [],
            invitationUseAllEligible: selectedItems.length > 1,
            invitationRecipientCount: 0
          },
          () => {
            const clubLabel = selectedItems.length === 1 ? selectedItems[0].name : `${selectedItems.length} clubs`;
            window.dispatchEvent(
              new CustomEvent('sit:topbar-breadcrumb', { detail: `Clubs / ${clubLabel} / Send invitations` })
            );
            if (!this.isPaidClubSelection()) this.openSendClubInvitationsPage();
          }
        );
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage: this.getErrorText(error, 'Failed to load the club booking form.')
        });
      });
  };

  isOneItemSelected(): boolean {
    const selectedItems = this.state.selectedItems;
    return selectedItems.length === 1;
  }

  getSummaryTabs(): React.ReactNode {
    const {
      currentTabIndex,
      selectedItems,
      clubParticipants,
      clubEvents,
      clubPayments,
      isErrorInPayments,
      errorMessageInPayments
    } = this.state;

    const { user } = this.props;
    const { activeSchool } = user;

    switch (currentTabIndex) {
      case 0:
        return <ClubSummary club={selectedItems[0]} school={activeSchool} />;
      case 1: {
        const club = selectedItems[0];
        const count = Array.isArray(club?.participants) ? club.participants.length : undefined;
        return (
          <div className="mt-2">
            <div className="font-weight-bold">Participants</div>
            <div className="text-muted">
              {typeof count === 'number' ? `Total participants: ${count}. ` : ''}
              Open the full list to view and manage participants.
            </div>
          </div>
        );
      }
      case 2:
        return <ClubActivateSummary club={selectedItems[0]} clubEvents={clubEvents} user={user} />;
      case 3:
        return (
          <div className="mt-2">
            <div className="font-weight-bold">Invitations &amp; Bookings</div>
            <div className="text-muted">Review invitation delivery and booking responses for this club.</div>
          </div>
        );
      case 4:
        return (
          <ClubPaymentsSummary
            clubTransactions={clubPayments}
            isErrorInPayments={isErrorInPayments}
            errorMessageInPayments={errorMessageInPayments}
            onCloseErrorInPaymentsClick={this.onCloseErrorInPaymentsClick}
          />
        );
      case 5:
        return (
          <ClubPaymentSettingsSummary user={user} club={selectedItems[0]} onSubmit={this.onUpdatePaymentSettings} />
        );
    }
  }

  onTabClick = (event, index: number) => {
    event.preventDefault();

    const selectedItems = this.state.selectedItems;
    const club = selectedItems[0];
    const isClubActive = club.status === CLUB_STATUS.ACTIVE;
    const clubId = club.id;
    const { user } = this.props;

    switch (index) {
      case 1:
        this.setState({
          currentTabIndex: index
        });
        break;
      case 2:
        if (isClubActive) {
          this.setState({
            isLoading: true
          });
          getClubEvents(user, clubId).then(events => {
            this.setState({
              currentTabIndex: index,
              clubEvents: events,
              isLoading: false
            });
          });
          break;
        } else {
          this.setState({
            currentTabIndex: index
          });
          break;
        }
      case 4:
        this.setState({
          isLoading: true
        });
        getClubPayments(user, clubId)
          .then(payments => {
            this.setState({
              currentTabIndex: index,
              clubPayments: payments,
              isLoading: false
            });
          })
          .catch(error => {
            console.error(error.response.data.details.text);
            this.setState({
              currentTabIndex: index,
              isLoading: false,
              isErrorInPayments: true,
              errorMessageInPayments: error.response.data.details.text
            });
          });
        break;
      default:
        this.setState({
          currentTabIndex: index
        });
    }
  };

  onCloseErrorInPaymentsClick = (event: Event) => {
    event.preventDefault();
    this.setState({
      isErrorInPayments: false,
      errorMessageInPayments: ''
    });
  };

  onBookingButtonClick = (): void => {
    this.sendInvitationsModalOpen();
  };

  onEligibleStudentsButtonClick = (): void => {
    const { selectedItems } = this.state;
    const { location } = this.props;
    const { search } = location;

    const club = selectedItems[0];
    const clubId = club.id;

    this.props.history.push({
      pathname: `${this.state.basePath}/students`,
      search: `club=${clubId}`,
      state: { search }
    });
  };

  onEditParticipantsButtonClick = (): void => {
    const club = this.state.selectedItems[0];
    const clubId = club.id;
    const search = propz.get(this.props, ['location', 'search']);

    this.props.history.push({
      pathname: `${this.state.basePath}/edit-participants`,
      search: `club=${clubId}`,
      state: {
        search,
        returnPath: this.state.basePath,
        clubId,
        currentTabIndex: 1
      }
    });
  };

  onEditEventsButtonClick = (): void => {
    const selectedItems = this.state.selectedItems;
    const club = selectedItems[0];
    const clubId = club.id;
    const search = propz.get(this.props, ['location', 'search']);

    this.props.history.push({
      pathname: `${this.state.basePath}/events`,
      search: `club=${clubId}`,
      state: { search }
    });
  };

  onSubmitReportForm = (data, reportType) => {
    const { user } = this.props;
    const { activeSchoolId, activeSchool } = user;
    const { selectedItems, forms } = this.state;
    const club = selectedItems[0];
    const clubId = propz.get(club, ['id'], '');
    const { ageGroupsNaming } = activeSchool;
    const ageGroup = propz.get(AGE_GROUPS_SORTED, [ageGroupsNaming]);

    const {
      dateTo,
      dateFrom,
      isPrintPP,
      isPrintSEN,
      isPrintFSM,
      isPrintEthnicity,
      isPrintEligible,
      isPrintPercent,
      isShowZero,
      isShowNonZero,
      genders,
      ages: ageItems,
      isGroupByForms,
      isGroupByYears,
      isGroupByKeyStages,
      isAttendance,
      isParticipation,
      isPrintMedicalInfo,
      isPrintNextOfKin,
      isPrintPriority,
      isShowAccepted,
      isShowRejected,
      isShowPending,
      isPrintCapacity,
      isCurrentWeek,
      isNextWeek
    } = data;

    let modData;
    let formsUniq;
    let ages: number[];

    switch (reportType) {
      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.AGGREGATE_CLUB_PARTICIPATION_FOR_PERIOD:
        this.setState({
          isAggregateClubParticipationReportModalOpen: false,
          isLoading: true
        });
        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);
        const formattedDateTo = moment(dateTo).format('YYYY-MM-DD HH:mm:ss');
        const formattedDateFrom = moment(dateFrom).format('YYYY-MM-DD HH:mm:ss');
        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            dateFrom: formattedDateFrom,
            dateTo: formattedDateTo,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printEthnicity: isPrintEthnicity,
            printFSM: isPrintFSM,
            groupByForms: isGroupByForms,
            groupByYears: isGroupByYears,
            groupByKeyStages: isGroupByKeyStages
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.CLUB_ATTENDANCE:
        this.setState({
          isClubAttendanceReportModalOpen: false,
          isLoading: true
        });
        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);
        modData = {
          reportParamsCSV: {
            dateTo: moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            clubId,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM,
            printEthnicity: isPrintEthnicity,
            attendance: isAttendance,
            participation: isParticipation
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.PARTICIPATION_STATISTICS_BY_CLUBS:
        this.setState({
          isParticipationByClubsReportModalOpen: false,
          isLoading: true
        });
        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        modData = {
          reportParamsCSV: {
            dateTo: moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            schoolId: activeSchoolId,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM,
            printEthnicity: isPrintEthnicity,
            showZero: isShowZero,
            showNonZero: isShowNonZero
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.CLUB_PARTICIPATION_STATISTICS_BY_STUDENTS:
        this.setState({
          isClubParticipationByStudentsReportModalOpen: false,
          isLoading: true
        });
        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        formsUniq = Lazy(forms)
          .uniq('age')
          .sort((form1, form2) => {
            const ageIndex1 = ageGroup.indexOf(form1.ageGroup);
            const ageIndex2 = ageGroup.indexOf(form2.ageGroup);

            return ageIndex1 - ageIndex2;
          })
          .toArray();

        ages = formsUniq.filter((form, index) => ageItems[index].isChecked).map(form => form.age);

        modData = {
          reportParamsCSV: {
            dateTo: moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            schoolId: activeSchoolId,
            showZero: isShowZero,
            showNonZero: isShowNonZero,
            genders: genders.filter(gender => gender.isChecked === true).map(gender => gender.name.toUpperCase()),
            ageGroups: ages,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM,
            printEthnicity: isPrintEthnicity
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.SELECTED_CLUBS_PARTICIPATION_BY_STUDENTS:
        this.setState({
          isSelectedClubParticipationByStudentsReportModalOpen: false,
          isLoading: true
        });
        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        formsUniq = Lazy(forms)
          .uniq('age')
          .sort((form1, form2) => {
            const ageIndex1 = ageGroup.indexOf(form1.ageGroup);
            const ageIndex2 = ageGroup.indexOf(form2.ageGroup);

            return ageIndex1 - ageIndex2;
          })
          .toArray();

        ages = formsUniq.filter((form, index) => ageItems[index].isChecked).map(form => form.age);

        modData = {
          reportParamsCSV: {
            dateTo: moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            clubId: selectedItems.map(item => item.id),
            schoolId: activeSchoolId,
            showZero: isShowZero,
            showNonZero: isShowNonZero,
            genders: genders.filter(gender => gender.isChecked === true).map(gender => gender.name.toUpperCase()),
            ageGroups: ages,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM,
            printEthnicity: isPrintEthnicity
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.CLUB_LIST_BY_STUDENTS:
        this.setState({
          isClubListByStudentsReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        formsUniq = Lazy(forms)
          .uniq('age')
          .sort((form1, form2) => sortAges(form1.age, form2.age, ageGroupsNaming))
          .toArray();

        ages = formsUniq.filter((form, index) => ageItems[index].isChecked).map(form => form.age);

        modData = {
          reportParamsCSV: {
            dateTo: moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            schoolId: activeSchoolId,
            genders: genders.filter(gender => gender.isChecked === true).map(gender => gender.name.toUpperCase()),
            ageGroups: ages,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM,
            printEthnicity: isPrintEthnicity
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.CLUB_ATTENDANCE_STATISTICS_BY_STUDENTS:
        this.setState({
          isClubAttendanceByStudentsReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        formsUniq = Lazy(forms)
          .uniq('age')
          .sort((form1, form2) => {
            const ageIndex1 = ageGroup.indexOf(form1.ageGroup);
            const ageIndex2 = ageGroup.indexOf(form2.ageGroup);

            return ageIndex1 - ageIndex2;
          })
          .toArray();

        ages = formsUniq.filter((form, index) => ageItems[index].isChecked).map(form => form.age);

        modData = {
          reportParamsCSV: {
            dateTo: moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            schoolId: activeSchoolId,
            genders: genders.filter(gender => gender.isChecked === true).map(gender => gender.name.toUpperCase()),
            ageGroups: ages,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM,
            printEthnicity: isPrintEthnicity
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.PARTICIPATION_STATISTICS_BY_CLUBS_YEAR_GROUPS:
        this.setState({
          isParticipationsByClubsYearGroupsReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        modData = {
          reportParamsCSV: {
            dateTo: moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            schoolId: activeSchoolId,
            printCapacity: isPrintCapacity,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM,
            printEthnicity: isPrintEthnicity,
            printEligible: isPrintEligible,
            printPercent: isPrintPercent
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.CLUB_BOOKINGS:
        this.setState({
          isClubBookingsReportModalOpen: false,
          isLoading: true
        });

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            clubId,
            printMedicalInfo: isPrintMedicalInfo,
            printNextOfKin: isPrintNextOfKin,
            printPriority: isPrintPriority,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM,
            printEthnicity: isPrintEthnicity,
            showAccepted: isShowAccepted,
            showRejected: isShowRejected,
            showPending: isShowPending,
            printResponseMetadata: true
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.WEEKLY_CLUB_SCHEDULE:
        this.setState({
          isWeeklyClubScheduleReportModalOpen: false,
          isLoading: true
        });
        formsUniq = Lazy(forms)
          .uniq('age')
          .sort((form1, form2) => {
            const ageIndex1 = ageGroup.indexOf(form1.ageGroup);
            const ageIndex2 = ageGroup.indexOf(form2.ageGroup);

            return ageIndex1 - ageIndex2;
          })
          .toArray();

        ages = formsUniq.filter((form, index) => ageItems[index].isChecked).map(form => form.age);

        modData = {
          reportParamsCSV: {
            schoolId: activeSchoolId,
            currentWeek: isCurrentWeek,
            nextWeek: isNextWeek,
            genders: genders.filter(gender => gender.isChecked === true).map(gender => gender.name.toUpperCase()),
            ageGroups: ages
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.DATE_CLUBS:
        this.setState({
          isDateClubsReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);

        modData = {
          reportParamsCSV: {
            dateFrom: moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            schoolId: activeSchoolId
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.CLUB_PARTICIPATION_BY_CLUB_NUMBER:
        this.setState({
          isClubParticipationByCLubNumberReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        modData = {
          reportParamsCSV: {
            dateTo: moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            schoolId: activeSchoolId,
            printEligible: isPrintEligible,
            printPP: isPrintPP,
            printSEN: isPrintSEN,
            printFSM: isPrintFSM,
            printEthnicity: isPrintEthnicity,
            groupByForms: isGroupByForms,
            groupByYears: isGroupByYears,
            groupByKeyStages: isGroupByKeyStages
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.AVERAGE_CLUB_ATTENDANCE:
        this.setState({
          isAverageClubAttendanceReportModalOpen: false,
          isLoading: true
        });
        formsUniq = Lazy(forms)
          .uniq('age')
          .sort((form1, form2) => {
            const ageIndex1 = ageGroup.indexOf(form1.ageGroup);
            const ageIndex2 = ageGroup.indexOf(form2.ageGroup);

            return ageIndex1 - ageIndex2;
          })
          .toArray();

        ages = formsUniq.filter((form, index) => ageItems[index].isChecked).map(form => form.age);

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        modData = {
          reportParamsCSV: {
            dateTo: moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            schoolId: activeSchoolId,
            genders: genders.filter(gender => gender.isChecked === true).map(gender => gender.name.toUpperCase()),
            ageGroups: ages
          }
        };
        break;

      case REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.PAPER_ATTENDANCE_REGISTER_CLUB:
        this.setState({
          isPaperAttendanceRegisterClubReportModalOpen: false,
          isLoading: true
        });

        dateFrom.setHours(0, 0, 0, 0);
        dateTo.setHours(23, 59, 59, 0);

        modData = {
          reportParamsCSV: {
            dateTo: moment(dateTo).format('YYYY-MM-DD HH:mm:ss'),
            dateFrom: moment(dateFrom).format('YYYY-MM-DD HH:mm:ss'),
            schoolId: activeSchoolId,
            clubId
          }
        };
        break;
    }

    uploadReport(user, reportType, modData)
      .then(data => {
        if (typeof data.reportId !== 'undefined') {
          const reportType = data.reportType;

          this.setState({
            isLoading: false
          });

          const url = `${window.apiBase}/public/report/${data.reportId}/reportType/${reportType}`;
          window.open(url);
        } else {
          this.setState({
            isLoading: false,
            errorMessage: 'No read report',
            isErrorModalOpen: true
          });
        }
      })
      .catch(error => {
        console.error('uploadReport error:', error);

        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);

        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  openAggregateClubParticipationReportForm = () => {
    this.setState({
      isAggregateClubParticipationReportModalOpen: true
    });
  };

  closeAggregateClubParticipationReportForm = () => {
    this.setState({
      isAggregateClubParticipationReportModalOpen: false
    });
  };

  openClubAttendanceReportForm = () => {
    this.setState({
      isClubAttendanceReportModalOpen: true
    });
  };

  closeClubAttendanceReportForm = () => {
    this.setState({
      isClubAttendanceReportModalOpen: false
    });
  };

  openClubParticipationByStudentsReportForm = () => {
    this.setState({
      isClubParticipationByStudentsReportModalOpen: true
    });
  };

  closeClubParticipationByStudentsReportForm = () => {
    this.setState({
      isClubParticipationByStudentsReportModalOpen: false
    });
  };

  openSelectedClubParticipationByStudentsReportForm = () => {
    this.setState({
      isSelectedClubParticipationByStudentsReportModalOpen: true
    });
  };

  closeSelectedClubParticipationByStudentsReportForm = () => {
    this.setState({
      isSelectedClubParticipationByStudentsReportModalOpen: false
    });
  };

  openParticipationByClubsReportForm = () => {
    this.setState({
      isParticipationByClubsReportModalOpen: true
    });
  };

  closeParticipationByClubsReportForm = () => {
    this.setState({
      isParticipationByClubsReportModalOpen: false
    });
  };

  openClubAttendanceByStudentsReportForm = () => {
    this.setState({
      isClubAttendanceByStudentsReportModalOpen: true
    });
  };

  closeClubAttendanceByStudentsReportForm = () => {
    this.setState({
      isClubAttendanceByStudentsReportModalOpen: false
    });
  };

  openParticipationsByClubsYearGroupsReportForm = () => {
    this.setState({
      isParticipationsByClubsYearGroupsReportModalOpen: true
    });
  };

  closeParticipationsByClubsYearGroupsReportForm = () => {
    this.setState({
      isParticipationsByClubsYearGroupsReportModalOpen: false
    });
  };

  openClubListByStudentsReportForm = () => {
    this.setState({
      isClubListByStudentsReportModalOpen: true
    });
  };

  closeClubListByStudentsReportForm = () => {
    this.setState({
      isClubListByStudentsReportModalOpen: false
    });
  };

  openClubBookingsReportForm = () => {
    this.setState({
      isClubBookingsReportModalOpen: true
    });
  };

  closeClubBookingsReportForm = () => {
    this.setState({
      isClubBookingsReportModalOpen: false
    });
  };

  openWeeklyClubScheduleReportForm = () => {
    this.setState({
      isWeeklyClubScheduleReportModalOpen: true
    });
  };

  closeWeeklyClubScheduleReportForm = () => {
    this.setState({
      isWeeklyClubScheduleReportModalOpen: false
    });
  };

  openDateClubsReportForm = () => {
    this.setState({
      isDateClubsReportModalOpen: true
    });
  };

  closeDateClubsReportForm = () => {
    this.setState({
      isDateClubsReportModalOpen: false
    });
  };

  openClubParticipationByClubNumberReportForm = () => {
    this.setState({
      isClubParticipationByCLubNumberReportModalOpen: true
    });
  };

  closeClubParticipationByClubNumberReportForm = () => {
    this.setState({
      isClubParticipationByCLubNumberReportModalOpen: false
    });
  };

  openAverageClubAttendanceReportForm = () => {
    this.setState({
      isAverageClubAttendanceReportModalOpen: true
    });
  };

  closeAverageClubAttendanceReportForm = () => {
    this.setState({
      isAverageClubAttendanceReportModalOpen: false
    });
  };

  openPaperAttendanceRegisterClubReportForm = () => {
    this.setState({
      isPaperAttendanceRegisterClubReportModalOpen: true
    });
  };

  closePaperAttendanceRegisterClubReportForm = () => {
    this.setState({
      isPaperAttendanceRegisterClubReportModalOpen: false
    });
  };

  getClubReportModalProps = (title: string, onCloseClick: () => void, compactTitle: boolean = false) => ({
    title: (
      <div className={compactTitle ? 'clubsReportModalTitle clubsReportModalTitle--compact' : 'clubsReportModalTitle'}>
        <span className="clubsReportModalTitle__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5" />
          </svg>
        </span>
        <span>
          <strong>{title}</strong>
          <small>Club report</small>
        </span>
      </div>
    ),
    onCloseClick,
    showFooter: false,
    isBodyBold: false,
    customClass: 'clubsModal clubsReportParametersModal eEventReportParametersModal',
    bodyClassName: 'clubsReportParametersModal__body eEventReportParametersModal__body'
  });

  renderAggregateClubParticipationReportFormModal() {
    const { isAggregateClubParticipationReportModalOpen } = this.state;
    const { user } = this.props;
    const activeSchool = user && user.activeSchool;
    const activeSchoolId = activeSchool ? activeSchool.id : null;

    return (
      <SimpleModal
        isOpen={isAggregateClubParticipationReportModalOpen}
        {...this.getClubReportModalProps(
          'Club participation summary by student group',
          this.closeAggregateClubParticipationReportForm
        )}
      >
        <AggregateClubParticipationReportForm
          onCloseClick={this.closeAggregateClubParticipationReportForm}
          onSubmit={this.onSubmitReportForm}
          activeSchoolId={activeSchoolId}
          school={activeSchool}
        />
      </SimpleModal>
    );
  }

  renderClubAttendanceReportFormModal() {
    const { isClubAttendanceReportModalOpen, selectedItems } = this.state;
    const club = selectedItems[0];
    const { user } = this.props;
    const activeSchoolId = user && user.activeSchool ? user.activeSchool.id : null;
    return (
      <SimpleModal
        isOpen={isClubAttendanceReportModalOpen}
        {...this.getClubReportModalProps('Selected club attendance register', this.closeClubAttendanceReportForm)}
      >
        <ClubAttendanceReportForm
          onCloseClick={this.closeClubAttendanceReportForm}
          onSubmit={this.onSubmitReportForm}
          club={club}
          activeSchoolId={activeSchoolId}
        />
      </SimpleModal>
    );
  }

  renderClubParticipationByStudentsReportFormModal() {
    const { isClubParticipationByStudentsReportModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    const activeSchoolId = user && user.activeSchool ? user.activeSchool.id : null;
    return (
      <SimpleModal
        isOpen={isClubParticipationByStudentsReportModalOpen}
        {...this.getClubReportModalProps('Student club participation', this.closeClubParticipationByStudentsReportForm)}
      >
        <ClubParticipationByStudentsReportForm
          onCloseClick={this.closeClubParticipationByStudentsReportForm}
          onSubmit={this.onSubmitReportForm}
          forms={forms}
          school={activeSchool}
          activeSchoolId={activeSchoolId}
        />
      </SimpleModal>
    );
  }

  renderSelectedClubParticipationByStudentsReportFormModal() {
    const { isSelectedClubParticipationByStudentsReportModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    const activeSchoolId = user && user.activeSchool ? user.activeSchool.id : null;
    return (
      <SimpleModal
        isOpen={isSelectedClubParticipationByStudentsReportModalOpen}
        {...this.getClubReportModalProps(
          'Student participation in selected clubs',
          this.closeSelectedClubParticipationByStudentsReportForm
        )}
      >
        <SelectedClubParticipationByStudentsReportForm
          onCloseClick={this.closeSelectedClubParticipationByStudentsReportForm}
          onSubmit={this.onSubmitReportForm}
          forms={forms}
          school={activeSchool}
          activeSchoolId={activeSchoolId}
        />
      </SimpleModal>
    );
  }

  renderClubListByStudentsReportFormModal() {
    const { isClubListByStudentsReportModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    const activeSchoolId = user && user.activeSchool ? user.activeSchool.id : null;

    return (
      <SimpleModal
        isOpen={isClubListByStudentsReportModalOpen}
        {...this.getClubReportModalProps('Student club memberships', this.closeClubListByStudentsReportForm)}
      >
        <ClubListByStudentsReportForm
          onCloseClick={this.closeClubListByStudentsReportForm}
          onSubmit={this.onSubmitReportForm}
          forms={forms}
          school={activeSchool}
          activeSchoolId={activeSchoolId}
        />
      </SimpleModal>
    );
  }

  renderParticipationsByClubsReportFormModal() {
    const { isParticipationByClubsReportModalOpen, forms } = this.state;
    const { user } = this.props;
    const activeSchoolId = user && user.activeSchool ? user.activeSchool.id : null;
    return (
      <SimpleModal
        isOpen={isParticipationByClubsReportModalOpen}
        {...this.getClubReportModalProps('Participation totals by club', this.closeParticipationByClubsReportForm)}
      >
        <ParticipationsByClubsReportForm
          onCloseClick={this.closeParticipationByClubsReportForm}
          onSubmit={this.onSubmitReportForm}
          activeSchoolId={activeSchoolId}
        />
      </SimpleModal>
    );
  }

  renderClubAttendancesByStudentsReportFormModal() {
    const { isClubAttendanceByStudentsReportModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    const activeSchoolId = user && user.activeSchool ? user.activeSchool.id : null;
    return (
      <SimpleModal
        isOpen={isClubAttendanceByStudentsReportModalOpen}
        {...this.getClubReportModalProps(
          'Student attendance across clubs',
          this.closeClubAttendanceByStudentsReportForm
        )}
      >
        <ClubAttendanceByStudentsReportForm
          onCloseClick={this.closeClubAttendanceByStudentsReportForm}
          onSubmit={this.onSubmitReportForm}
          forms={forms}
          school={activeSchool}
          activeSchoolId={activeSchoolId}
        />
      </SimpleModal>
    );
  }

  renderParticipationsByClubsYearGroupsReportFormModal() {
    const {
      isParticipationsByClubsYearGroupsReportModalOpen: isOpenParticipationsByClubsYearGroups,
      forms
    } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    const activeSchoolId = user && user.activeSchool ? user.activeSchool.id : null;
    return (
      <SimpleModal
        isOpen={isOpenParticipationsByClubsYearGroups}
        {...this.getClubReportModalProps(
          'Club participation by year group',
          this.closeParticipationsByClubsYearGroupsReportForm
        )}
      >
        <ParticipationsByClubsYearGroupsReportForm
          onCloseClick={this.closeParticipationsByClubsYearGroupsReportForm}
          onSubmit={this.onSubmitReportForm}
          activeSchoolId={activeSchoolId}
        />
      </SimpleModal>
    );
  }

  renderClubBookingsReportFormModal() {
    const { isClubBookingsReportModalOpen, selectedItems } = this.state;
    const club = selectedItems[0];
    const { user } = this.props;
    const activeSchoolId = user && user.activeSchool ? user.activeSchool.id : null;
    return (
      <SimpleModal
        isOpen={isClubBookingsReportModalOpen}
        {...this.getClubReportModalProps('Club booking summary', this.closeClubBookingsReportForm)}
      >
        <ClubBookingsReportForm
          onCloseClick={this.closeClubBookingsReportForm}
          onSubmit={this.onSubmitReportForm}
          club={club}
          activeSchoolId={activeSchoolId}
        />
      </SimpleModal>
    );
  }

  renderWeeklyClubScheduleReportFormModal() {
    const { isWeeklyClubScheduleReportModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return (
      <SimpleModal
        isOpen={isWeeklyClubScheduleReportModalOpen}
        {...this.getClubReportModalProps('Weekly club timetable', this.closeWeeklyClubScheduleReportForm)}
      >
        <WeeklyClubScheduleReportForm
          onCloseClick={this.closeWeeklyClubScheduleReportForm}
          onSubmit={this.onSubmitReportForm}
          forms={forms}
          school={activeSchool}
        />
      </SimpleModal>
    );
  }

  renderDateClubsReportFormModal() {
    const { isDateClubsReportModalOpen: isOpenDateClubs, forms } = this.state;
    return (
      <SimpleModal
        isOpen={isOpenDateClubs}
        {...this.getClubReportModalProps('Clubs running on a selected date', this.closeDateClubsReportForm)}
      >
        <DateClubsReportForm onCloseClick={this.closeDateClubsReportForm} onSubmit={this.onSubmitReportForm} />
      </SimpleModal>
    );
  }

  renderClubParticipationByClubNumberReportFormModal() {
    const { isClubParticipationByCLubNumberReportModalOpen } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    const activeSchoolId = user && user.activeSchool ? user.activeSchool.id : null;
    return (
      <SimpleModal
        isOpen={isClubParticipationByCLubNumberReportModalOpen}
        {...this.getClubReportModalProps(
          'Students by number of clubs attended',
          this.closeClubParticipationByClubNumberReportForm
        )}
      >
        <ClubParticipationByClubNumberReportForm
          onCloseClick={this.closeClubParticipationByClubNumberReportForm}
          onSubmit={this.onSubmitReportForm}
          activeSchoolId={activeSchoolId}
          school={activeSchool}
        />
      </SimpleModal>
    );
  }

  renderAverageClubAttendanceReportFormModal() {
    const { isAverageClubAttendanceReportModalOpen, forms } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    return (
      <SimpleModal
        isOpen={isAverageClubAttendanceReportModalOpen}
        {...this.getClubReportModalProps('Average attendance by club', this.closeAverageClubAttendanceReportForm)}
      >
        <AverageClubAttendanceReportForm
          onCloseClick={this.closeAverageClubAttendanceReportForm}
          onSubmit={this.onSubmitReportForm}
          forms={forms}
          school={activeSchool}
        />
      </SimpleModal>
    );
  }

  renderPaperAttendanceRegisterClubReportFormModal() {
    const { isPaperAttendanceRegisterClubReportModalOpen, selectedItems } = this.state;
    const { user } = this.props;
    const { activeSchool } = user;
    const club = selectedItems[0];
    return (
      <SimpleModal
        isOpen={isPaperAttendanceRegisterClubReportModalOpen}
        {...this.getClubReportModalProps(
          'Printable attendance register',
          this.closePaperAttendanceRegisterClubReportForm
        )}
      >
        <PaperAttendanceRegisterClubReportForm
          onCloseClick={this.closePaperAttendanceRegisterClubReportForm}
          onSubmit={this.onSubmitReportForm}
          club={club}
        />
      </SimpleModal>
    );
  }

  getTabs() {
    const { user } = this.props;
    const isPaymentsEnabled = propz.get(user, ['activeSchool', 'isPaymentsEnabled'], false);

    return isPaymentsEnabled ? CLUB_TABS_ARRAY : CLUB_TABS_FOR_SCHOOL_WITHOUT_PAYMENT;
  }

  renderSummary(): React.ReactNode {
    const isOneItemSelected = this.isOneItemSelected();

    if (!isOneItemSelected) {
      return <div className="font-weight-bold">Select a club above</div>;
    }

    const { currentTabIndex, selectedItems, clubEvents } = this.state;

    const club = selectedItems[0];
    const isClubActive = club.status === CLUB_STATUS.ACTIVE;

    const summaryTabs = this.getSummaryTabs();

    const isShowActivateButton = currentTabIndex === 2 && !isClubActive;
    const isShowEditParticipantsButton = currentTabIndex === 1;

    const isShowBookingButton = currentTabIndex === 0;
    const isShowEligibleStudentsButton = currentTabIndex === 0 && !isClubActive;

    const isShowEditEventsButton = currentTabIndex === 2 && clubEvents.length > 0;

    const tabs = this.getTabs();

    return (
      <GenericSummary onTabClick={this.onTabClick} tabs={tabs} currentTabIndex={currentTabIndex}>
        {isShowBookingButton && (
          <Button onClick={this.onBookingButtonClick} text={'Invitations'} customClass={'mt-3 mb-3 mr-3'} />
        )}

        {isShowEligibleStudentsButton && (
          <Button
            onClick={this.onEligibleStudentsButtonClick}
            text={'Eligible students'}
            customClass={'mt-3 mb-3 mr-3'}
          />
        )}

        {isShowActivateButton && (
          <Button onClick={this.activateClubModalOpen} text={'Activate'} customClass={'mt-3 mb-3'} />
        )}

        {isShowEditParticipantsButton && (
          <Button onClick={this.onEditParticipantsButtonClick} text={'Edit'} customClass={'mt-3 mb-3'} />
        )}

        {isShowEditEventsButton && (
          <Button onClick={this.onEditEventsButtonClick} text={'Manage events'} customClass={'mt-3 mb-3'} />
        )}

        {summaryTabs}
      </GenericSummary>
    );
  }

  getClubColumnsStorageKey(): string {
    const schoolId = propz.get(this.props.user, ['activeSchool', 'id'], 'school');
    const userId = propz.get(this.props.user, ['userId'], 'user');
    const role = propz.get(this.props.user, ['activePermission', 'preset'], 'role');
    return `sit.clubs.hiddenColumns:${schoolId}:${userId}:${role}`;
  }

  getInitialClubColumnKeys(): string[] {
    try {
      return JSON.parse(window.localStorage.getItem(this.getClubColumnsStorageKey()) || '[]');
    } catch (error) {
      return [];
    }
  }

  persistClubColumnKeys(hiddenClubColumnKeys: string[]): void {
    try {
      window.localStorage.setItem(this.getClubColumnsStorageKey(), JSON.stringify(hiddenClubColumnKeys));
    } catch (error) {
      // Keep the UI usable when storage is unavailable.
    }
  }

  toggleClubColumn = (field: string): void => {
    const hiddenColumns = new Set(this.state.hiddenClubColumnKeys);

    if (hiddenColumns.has(field)) {
      hiddenColumns.delete(field);
    } else {
      hiddenColumns.add(field);
    }

    const hiddenClubColumnKeys = Array.from(hiddenColumns);
    this.persistClubColumnKeys(hiddenClubColumnKeys);
    this.setState({ hiddenClubColumnKeys });
  };

  resetClubColumns = (): void => {
    this.persistClubColumnKeys([]);
    this.setState({ hiddenClubColumnKeys: [] });
  };

  onClubDocumentMouseDown = (event: MouseEvent): void => {
    const target = event.target as HTMLElement;
    if (
      target &&
      target.closest &&
      (target.closest('.clubsDsColumns') ||
        target.closest('.clubsDsFilterAnchor') ||
        target.closest('.clubsDsFilters') ||
        target.closest('.sit-dp__pop'))
    ) {
      return;
    }

    const shouldRestoreFilters = this.state.isShowFilter;
    if (this.state.isColumnsMenuOpen || shouldRestoreFilters) {
      this.setState({ isColumnsMenuOpen: false, isShowFilter: false });
      if (shouldRestoreFilters) this.setItems();
    }
  };

  onClubDocumentKeyDown = (event: KeyboardEvent): void => {
    if (event.key !== 'Escape') return;
    if (this.state.isInvitationExitConfirmOpen) {
      this.setState({ isInvitationExitConfirmOpen: false });
      return;
    }
    if (this.state.isSendInvitationsModalOpen) {
      event.preventDefault();
      this.sendInvitationsModalClose();
      return;
    }
    if (this.state.isInvitationSuccessModalOpen) {
      this.closeInvitationSuccessModal();
      return;
    }
    const shouldRestoreFilters = this.state.isShowFilter;
    this.setState({ isColumnsMenuOpen: false, isShowFilter: false });
    if (shouldRestoreFilters) this.setItems();
  };

  getDsFilterValues(field: string): string[] {
    const value = this.state.filters[field];

    if (Array.isArray(value)) {
      return value
        .map(item => (item && typeof item === 'object' ? item.value : item))
        .filter(item => typeof item !== 'undefined' && item !== null && item !== '')
        .map(item => String(item));
    }

    if (value && typeof value === 'object') {
      return [];
    }

    return typeof value === 'undefined' || value === '' ? [] : [String(value)];
  }

  setDsFilterValues = (field: string, values: string[]): void => {
    this.setState({
      filters: {
        ...this.state.filters,
        [field]: values
      }
    });
  };

  toggleDsFilterValue = (field: string, value: string): void => {
    const values = this.getDsFilterValues(field);
    const nextValues = values.includes(value) ? values.filter(item => item !== value) : [...values, value];
    this.setDsFilterValues(field, nextValues);
  };

  setDsSingleFilterValue = (field: string, value: string): void => {
    this.setState({
      filters: {
        ...this.state.filters,
        [field]: value
      }
    });
  };

  setDsDateFilterValue = (field: string, part: 'from' | 'to', value: string): void => {
    const currentFilterField = this.state.filters[field] || {};
    this.setState({
      filters: {
        ...this.state.filters,
        [field]: {
          ...currentFilterField,
          [part]: value
        }
      }
    });
  };

  getDsDateFilterDate(value: string): Date | null {
    if (!value) {
      return null;
    }

    const date = moment(value, 'DD-MM-YYYY', true);
    return date.isValid() ? date.toDate() : null;
  }

  setDsDateRangeFilterValue = (field: string, value: any): void => {
    const start = value && value.start ? moment(value.start).format('DD-MM-YYYY') : '';
    const end = value && value.end ? moment(value.end).format('DD-MM-YYYY') : '';

    this.setState({
      filters: {
        ...this.state.filters,
        [field]: {
          from: start,
          to: end
        }
      }
    });
  };

  removeDsActiveFilter = (field: string, value?: string): void => {
    const filters = { ...this.state.filters };
    if (typeof value === 'undefined' || !Array.isArray(filters[field])) {
      delete filters[field];
    } else {
      const next = this.getDsFilterValues(field).filter(item => item !== value);
      if (next.length) filters[field] = next;
      else delete filters[field];
    }
    this.setState({ filters }, this.onApplyFilterClick);
  };

  renderDsActiveFilterChips(): React.ReactNode {
    const { forms, filters } = this.state;
    const ageGroupName = propz.get(this.props.user, ['activeSchool', 'ageGroupsNaming'], '');
    const definitions: any[] = [
      { field: 'status', label: 'Status', options: getSelectOptionForClubStatus() },
      { field: 'clubAcademicYear', label: 'Academic year', options: getSelectOptionForClubAcademicYears() },
      { field: 'gender', label: 'Gender', options: getSelectOptionForClubGender() },
      { field: 'clubAges', label: 'Ages', options: getSelectOptionForAge(forms, ageGroupName) },
      { field: 'clubWeekDays', label: 'Week day', options: getSelectOptionForClubWeekDays() },
      { field: 'clubRecurrence', label: 'Recurrence', options: getSelectOptionForClubRecurrence() }
    ];
    const chips: Array<{ field: string; value?: string; text: string }> = [];

    if (String(filters.name || '').trim()) {
      chips.push({ field: 'name', text: `Club: ${String(filters.name).trim()}` });
    }

    definitions.forEach(definition => {
      const labels = (definition.options || []).reduce((result, option) => {
        result[String(option.value)] = option.text || option.label || String(option.value);
        return result;
      }, {});
      this.getDsFilterValues(definition.field).forEach(value =>
        chips.push({
          field: definition.field,
          value,
          text: `${definition.label}: ${labels[value] || value}`
        })
      );
    });

    const dateValue = filters.clubStartDate || {};
    if (dateValue.from || dateValue.to) {
      chips.push({
        field: 'clubStartDate',
        text: `Start date: ${[dateValue.from, dateValue.to].filter(Boolean).join(' – ')}`
      });
    }

    if (!chips.length) return null;
    return (
      <div className="clubsDsActiveFilters">
        {chips.map(chip => (
          <button
            type="button"
            key={`${chip.field}-${chip.value || 'range'}`}
            onClick={() => this.removeDsActiveFilter(chip.field, chip.value)}
          >
            {chip.text} <span aria-hidden="true">×</span>
          </button>
        ))}
        <button type="button" className="isClear" onClick={this.onClearFilterClick}>
          Clear all
        </button>
      </div>
    );
  }
  getClubStatusMeta(club: Club) {
    const status = club.status;
    switch (status) {
      case CLUB_STATUS.ACTIVE:
        return { label: 'Active', className: 'isSuccess' };
      case CLUB_STATUS.DRAFT:
        return { label: 'Draft', className: 'isWarning' };
      case CLUB_STATUS.ARCHIVED:
        return { label: 'Archived', className: 'isNeutral' };
      default:
        return { label: getClubStatus(club), className: 'isNeutral' };
    }
  }

  getDisplayedClubs(): Club[] {
    return this.state.items;
  }

  isClubChecked = (club: Club): boolean => {
    return this.state.selectedItems.some(item => item.id === club.id);
  };

  onClubCheckboxChange = (club: Club, isChecked: boolean): void => {
    const { selectedItems } = this.state;
    const nextSelectedItems = isChecked
      ? selectedItems.some(item => item.id === club.id)
        ? selectedItems
        : [...selectedItems, club]
      : selectedItems.filter(item => item.id !== club.id);

    this.setState({
      selectedItems: nextSelectedItems,
      isSelectAllChecked: false
    });
  };

  onDsSelectPageClick = (): void => {
    const clubs = this.getDisplayedClubs();
    const selectedItems = [...this.state.selectedItems];

    clubs.forEach(club => {
      if (!selectedItems.some(item => item.id === club.id)) {
        selectedItems.push(club);
      }
    });

    this.setState({ selectedItems, isSelectAllChecked: true });
  };

  onDsClearSelectionClick = (): void => {
    this.setState({ selectedItems: [], isSelectAllChecked: false });
  };

  onClubPreviewClick = (club: Club): void => {
    this.setState({
      previewItem: club,
      currentTabIndex: 0,
      clubParticipants: [],
      isClubParticipantsLoading: false,
      isClubEventsLoading: false,
      clubEventSummary: { total: 0, upcoming: 0, past: 0, cancelled: 0 },
      clubInvitationSummary: { eligible: 0, sent: 0, accepted: 0, rejected: 0, pending: 0, notSent: 0 },
      isClubInvitationSummaryLoading: false
    });
  };

  closeClubPreview = (): void => {
    this.setState({
      previewItem: undefined,
      currentTabIndex: 0,
      clubParticipants: [],
      isClubParticipantsLoading: false,
      isClubEventsLoading: false,
      clubEventSummary: { total: 0, upcoming: 0, past: 0, cancelled: 0 },
      clubInvitationSummary: { eligible: 0, sent: 0, accepted: 0, rejected: 0, pending: 0, notSent: 0 },
      isClubInvitationSummaryLoading: false
    });
  };

  onClubDrawerTabClick = (club: Club, index: number): void => {
    const tab = this.getTabs()[index];
    this.setState({ currentTabIndex: index });
    if (tab === CLUB_TABS.INVITATIONS_AND_BOOKINGS) {
      this.loadClubInvitationSummary(club);
      return;
    }
    if (tab === CLUB_TABS.CLUB_EVENTS) {
      const now = new Date().toISOString();
      const nonEventStatuses = [EVENT_STATUS.CANCELED, EVENT_STATUS.REJECTED];
      this.setState({ isClubEventsLoading: true });
      BPromise.all([
        getClubEventsCount(this.props.user, club.id, {}),
        getClubEventsCount(this.props.user, club.id, {
          startTime: { $gte: now },
          status: { $nin: nonEventStatuses }
        }),
        getClubEventsCount(this.props.user, club.id, {
          startTime: { $lt: now },
          status: { $nin: nonEventStatuses }
        }),
        getClubEventsCount(this.props.user, club.id, { status: { $in: nonEventStatuses } })
      ])
        .then(([total, upcoming, past, cancelled]) => {
          if (this.state.previewItem?.id !== club.id) return;
          this.setState({
            clubEventSummary: {
              total: total.count || 0,
              upcoming: upcoming.count || 0,
              past: past.count || 0,
              cancelled: cancelled.count || 0
            },
            isClubEventsLoading: false
          });
        })
        .catch(() => {
          if (this.state.previewItem?.id !== club.id) return;
          this.setState({
            clubEventSummary: { total: 0, upcoming: 0, past: 0, cancelled: 0 },
            isClubEventsLoading: false
          });
        });
      return;
    }
    if (tab !== CLUB_TABS.PARTICIPANT) return;

    this.setState({ isClubParticipantsLoading: true });
    getAllClubParticipants(this.props.user, club.id)
      .then(participants =>
        this.setState({
          clubParticipants: Array.isArray(participants) ? [...participants].sort(sortPlayersByLastNameAsc) : [],
          isClubParticipantsLoading: false
        })
      )
      .catch(() => this.setState({ clubParticipants: [], isClubParticipantsLoading: false }));
  };

  loadClubInvitationSummary = (club: Club, context: 'DRAWER' | 'FLOW' = 'DRAWER'): void => {
    const { user } = this.props;
    const statusWhere = (invitationStatus: string) => ({ invitationStatus: { $in: [invitationStatus] } });
    const acceptableUsersStatusWhere = (messageStatus: string) => ({
      isParticipant: false,
      messageStatus
    });
    const isStillCurrent = () =>
      context === 'FLOW'
        ? this.state.selectedItems.length === 1 && this.state.selectedItems[0].id === club.id
        : Boolean(this.state.previewItem && this.state.previewItem.id === club.id);
    const pendingCountRequest =
      context === 'FLOW'
        ? getClubStudentsCountPost(user, club.id, acceptableUsersStatusWhere('PENDING'))
        : BPromise.resolve({ count: 0 });
    const notSentCountRequest =
      context === 'FLOW'
        ? getClubStudentsCountPost(user, club.id, acceptableUsersStatusWhere('NOT_SENT'))
        : BPromise.resolve({ count: 0 });
    const eligibleCountRequest =
      context === 'DRAWER'
        ? getClubStudentsCount(user, club.id, { participant: false })
        : BPromise.resolve({ count: 0 });

    this.setState({ isClubInvitationSummaryLoading: true });
    BPromise.all([
      eligibleCountRequest,
      getClubMessagesCount(user, club.id, undefined),
      getClubMessagesCount(user, club.id, statusWhere('ACCEPTED')),
      getClubMessagesCount(user, club.id, statusWhere('REJECTED')),
      pendingCountRequest,
      notSentCountRequest
    ])
      .then(([eligible, sent, accepted, rejected, pending, notSent]) => {
        if (!isStillCurrent()) return;
        this.setState({
          clubInvitationSummary: {
            eligible: eligible.count || 0,
            sent: sent.count || 0,
            accepted: accepted.count || 0,
            rejected: rejected.count || 0,
            pending: pending.count || 0,
            notSent: notSent.count || 0
          },
          isClubInvitationSummaryLoading: false
        });
      })
      .catch(() => {
        if (!isStillCurrent()) return;
        this.setState({ isClubInvitationSummaryLoading: false });
      });
  };

  openClubBookings = (club: Club): void => {
    this.props.history.push({
      pathname: `${this.state.basePath}/messages`,
      search: `club=${club.id}`,
      state: { search: this.props.location.search }
    });
  };

  runForClub = (club: Club, action: () => void): void => {
    this.setState({ selectedItems: [club], previewItem: club }, action);
  };

  getClubAgesLabel(club: Club): string {
    const ages = Array.isArray(club.ages) ? club.ages : [];
    const availableAgesCount = Lazy(this.state.forms)
      .map(form => form.age)
      .uniq()
      .toArray().length;

    if (ages.length === 0 || (availableAgesCount > 0 && ages.length >= availableAgesCount)) {
      return 'All ages';
    }

    return getAgesGroupFormatted({ ages: [...ages] }, { user: this.props.user }).replace(/\s+-\s+/g, '-');
  }
  renderClubStatusBadge(club: Club): React.ReactNode {
    const status = this.getClubStatusMeta(club);
    return <span className={`clubsDsBadge ${status.className}`}>{status.label}</span>;
  }

  renderClubDays(club: Club): React.ReactNode {
    const days = propz.get(club, ['schedule', 'days'], []) as string[];
    const labels = Array.isArray(days) && days.length ? days : [];

    return (
      <div className="clubsDsChips">
        {labels.length ? (
          labels.map(day => <span key={day}>{WEEK_DAYS_SHORT_SERVER_TO_CLIENT_MAPPING[day] || day}</span>)
        ) : (
          <span>Not set</span>
        )}
      </div>
    );
  }

  renderClubSelectionBar(): React.ReactNode {
    const { selectedItems } = this.state;
    const selectedCount = selectedItems.length;

    if (selectedCount === 0) {
      return null;
    }

    const isOne = selectedCount === 1;
    const canDelete = this.isDeleteClubStatusDraft();
    const canActivate = this.isActivateClubAndSendInvitationsActive();
    const canArchive = selectedItems.every(club => club.status === CLUB_STATUS.ACTIVE);
    const canRestore = selectedItems.every(club => club.status === CLUB_STATUS.ARCHIVED);

    return (
      <div className="clubsDsSelectionBar">
        <div className="clubsDsSelectionCount">{selectedCount} selected</div>
        {canActivate && (
          <button type="button" className="clubsDsBtn clubsDsBtnSecondary" onClick={this.sendInvitationsModalOpen}>
            Send invitations
          </button>
        )}
        {canActivate && (
          <button type="button" className="clubsDsBtn clubsDsBtnSecondary" onClick={this.activateClubModalOpen}>
            {isOne ? 'Activate' : 'Activate all'}
          </button>
        )}
        {isOne && !canRestore && (
          <button type="button" className="clubsDsBtn clubsDsBtnSecondary" onClick={this.onEditClubWithWizardClick}>
            Edit
          </button>
        )}
        {isOne && (
          <div className="clubsDsMenu">
            <button type="button" className="clubsDsBtn clubsDsBtnSecondary">
              <span aria-hidden="true">•••</span> More actions
            </button>
            <div className="clubsDsMenuPanel">
              <button type="button" onClick={() => this.onCopyClubWithWizardClick(MODE_TYPE.CLUB_COPY)}>
                Create a copy — settings only
              </button>
              <button
                type="button"
                onClick={() => this.onCopyClubWithWizardClick(MODE_TYPE.CLUB_COPY_WITH_PARTICIPANTS)}
              >
                Create a copy — settings and participants
              </button>
            </div>
          </div>
        )}
        {canArchive && (
          <button type="button" className="clubsDsBtn clubsDsBtnSecondary" onClick={this.onArchiveClubClick}>
            {isOne ? 'Archive' : 'Archive all'}
          </button>
        )}
        {canRestore && (
          <button type="button" className="clubsDsBtn clubsDsBtnSecondary" onClick={this.onRestoreClubClick}>
            {isOne ? 'Restore as draft' : 'Restore all as drafts'}
          </button>
        )}
        {canDelete && (
          <button type="button" className="clubsDsBtn clubsDsBtnDanger" onClick={this.deleteClubModalOpen}>
            {isOne ? 'Delete' : 'Delete all'}
          </button>
        )}
        <button type="button" className="clubsDsBtn clubsDsBtnGhost" onClick={this.onDsClearSelectionClick}>
          Clear
        </button>
      </div>
    );
  }

  getClubDsColumns(): ClubDsColumn[] {
    return [
      {
        field: 'name',
        text: 'Name',
        isSort: true,
        locked: true,
        render: club => (
          <div className="clubsDsClubCell">
            <span>
              <strong>{club.name}</strong>
              <small>{propz.get(club, ['sport', 'name'], '') || 'Activity not set'}</small>
            </span>
          </div>
        )
      },
      { field: 'clubAcademicYear', text: 'Academic year', render: club => getClubAcademicYear(club) },
      { field: 'clubStartDate', text: 'Start date', isSort: true, render: club => getClubStartDate(club) },
      { field: 'gender', text: 'Gender', isSort: true, render: club => getClubGender(club) },
      { field: 'clubAges', text: 'Ages', render: club => this.getClubAgesLabel(club) },
      { field: 'clubCoaches', text: 'Leader / Coach', render: club => getClubCoaches(club) || '-' },
      { field: 'clubMembersOfStaff', text: 'Member of staff', render: club => getClubMembersOfStaff(club) || '-' },
      { field: 'clubWeekDays', text: 'Week days', render: club => this.renderClubDays(club) },
      { field: 'clubRecurrence', text: 'Recurrence', render: club => getClubRecurrence(club) },
      { field: 'clubStartTime', text: 'Start time', render: club => getClubStartTime(club) },
      { field: 'status', text: 'Status', isSort: true, render: club => this.renderClubStatusBadge(club) }
    ];
  }

  getVisibleClubDsColumns(): ClubDsColumn[] {
    const hiddenColumns = new Set(this.state.hiddenClubColumnKeys);
    return this.getClubDsColumns().filter(column => column.locked || !hiddenColumns.has(column.field));
  }

  renderClubTable(): React.ReactNode {
    const clubs = this.getDisplayedClubs();
    const { selectedItems, sortColumnsName, sortDirection } = this.state;
    const visibleColumns = this.getVisibleClubDsColumns();
    const allOnPageSelected = clubs.length > 0 && clubs.every(club => selectedItems.some(item => item.id === club.id));

    return (
      <div className="clubsDsTableCard">
        <div className="clubsDsTableScroll">
          <table className="clubsDsTable">
            <thead>
              <tr>
                <th className="clubsDsCheckCell">
                  <SelectAllCheckbox
                    compact
                    isChecked={allOnPageSelected || this.state.isSelectAllChecked}
                    totalCount={this.state.totalWithFilters}
                    currentPage={this.state.currentPage}
                    pageItemsCount={clubs.length}
                    selectedItems={selectedItems}
                    onSelectAllOnPageClick={this.onDsSelectPageClick}
                    onSelectAllClick={this.onSelectAllClick}
                    onUnselectAllClick={this.onDsClearSelectionClick}
                  />
                </th>
                {visibleColumns.map(column => {
                  const isSorted = sortColumnsName === column.field;
                  return (
                    <th key={column.field}>
                      {column.isSort ? (
                        <button
                          type="button"
                          className="clubsDsSort"
                          onClick={() => this.onTableSortClick(column.field)}
                        >
                          {column.text} {isSorted ? (sortDirection === 'ASC' ? '↑' : '↓') : ''}
                        </button>
                      ) : (
                        column.text
                      )}
                    </th>
                  );
                })}
                <th className="clubsDsOpenCell" aria-label="Open club" />
              </tr>
            </thead>
            <tbody>
              {clubs.length === 0 ? (
                <tr>
                  <td colSpan={visibleColumns.length + 2} className="clubsDsEmpty">
                    <ListEmptyState
                      icon={faRunning}
                      title={this.state.isDataFiltered ? 'No clubs match your filters' : 'No clubs yet'}
                      description={
                        this.state.isDataFiltered
                          ? 'Try changing or clearing the search and filters to see other clubs.'
                          : 'Create a club to manage its schedule, participants, bookings and attendance.'
                      }
                    />
                  </td>
                </tr>
              ) : (
                clubs.map(club => {
                  const checked = this.isClubChecked(club);
                  const isPreview = this.state.previewItem && this.state.previewItem.id === club.id;
                  return (
                    <tr
                      key={club.id}
                      className={isPreview ? 'isPreview' : ''}
                      onClick={() => this.onClubPreviewClick(club)}
                    >
                      <td className="clubsDsCheckCell" onClick={event => event.stopPropagation()}>
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={event => this.onClubCheckboxChange(club, event.target.checked)}
                        />
                      </td>
                      {visibleColumns.map(column => (
                        <td key={column.field}>{column.render(club)}</td>
                      ))}
                      <td className="clubsDsOpenCell">
                        <span aria-hidden="true">›</span>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
  renderDsIcon(name: string): React.ReactNode {
    const paths = {
      filter: 'M4 6h16M7 12h10M10 18h4',
      columns: 'M4 5h16v14H4zM9 5v14M15 5v14',
      plus: 'M12 5v14M5 12h14',
      reports: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5',
      whistle: 'M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z',
      edit: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4z',
      ticket:
        'M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4zM9 6v12',
      power: 'M12 2v10M18.4 6.6a9 9 0 1 1-12.8 0',
      users:
        'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
      x: 'M18 6 6 18M6 6l12 12'
    };
    const path = paths[name] || paths.whistle;
    return (
      <svg
        viewBox="0 0 24 24"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d={path} />
      </svg>
    );
  }

  renderClubDrawer(): React.ReactNode {
    const {
      previewItem,
      currentTabIndex,
      clubParticipants,
      isClubParticipantsLoading,
      isClubEventsLoading,
      clubEventSummary,
      clubInvitationSummary,
      isClubInvitationSummaryLoading
    } = this.state;
    const club = previewItem;

    if (!club) {
      return null;
    }

    const tabs = this.getTabs();
    const activeTab = tabs[currentTabIndex] || tabs[0];
    const isActive = club.status === CLUB_STATUS.ACTIVE;
    const price = propz.get(club, ['price', 'price'], 0);
    const priceType = propz.get(club, ['price', 'priceType'], 'FREE');
    const venue = propz.get(club, ['venue', 'placeName'], 'Not set');
    const participantsCount = Array.isArray(club.participants) ? club.participants.length : 0;
    const invitationAudience = getClubInvitations(this.props.user.activeSchool.clubInvitations, club);
    const invitationAudienceLabel =
      CLUB_INVITATIONS_SERVER_TO_CLIENT_MAPPING[invitationAudience] || 'Students or parents';
    const answeredCount = clubInvitationSummary.accepted + clubInvitationSummary.rejected;

    return (
      <>
        <div className="clubsDsDrawerScrim" onClick={this.closeClubPreview} aria-hidden="true" />
        <aside className="clubsDsDrawer" role="dialog" aria-modal="true" aria-label={`${club.name} details`}>
          <div className="clubsDsDrawerHeader">
            <div className="clubsDsDrawerIcon">{this.renderDsIcon('whistle')}</div>
            <div>
              <h2>{club.name}</h2>
              <div className="clubsDsDrawerMeta">
                {this.renderClubStatusBadge(club)}
                <span>{propz.get(club, ['sport', 'name'], '')}</span>
                <span>{getClubAcademicYear(club)}</span>
              </div>
            </div>
            <button
              type="button"
              className="clubsDsIconBtn"
              onClick={this.closeClubPreview}
              aria-label="Close club details"
            >
              {this.renderDsIcon('x')}
            </button>
          </div>

          <div className="clubsDsDrawerTabs">
            {tabs.map((tab, index) => (
              <button
                key={tab}
                type="button"
                className={index === currentTabIndex ? 'isActive' : ''}
                onClick={() => this.onClubDrawerTabClick(club, index)}
              >
                {tab === CLUB_TABS.PARTICIPANT ? `Participants (${clubParticipants.length || participantsCount})` : tab}
              </button>
            ))}
          </div>

          <div className="clubsDsDrawerBody">
            {activeTab === CLUB_TABS.SUMMARY && (
              <div className="clubsDsDetailsGrid">
                <div>
                  <span>Activity</span>
                  <strong>{propz.get(club, ['sport', 'name'], '') || <em>Not set</em>}</strong>
                </div>
                <div>
                  <span>Audience</span>
                  <strong>
                    {getClubGender(club)} - {this.getClubAgesLabel(club)}
                  </strong>
                </div>
                <div>
                  <span>Runs</span>
                  <strong>
                    {getClubWeekDays(club)} at {getClubStartTime(club)}
                  </strong>
                </div>
                <div>
                  <span>Recurrence</span>
                  <strong>{getClubRecurrence(club)}</strong>
                </div>
                <div>
                  <span>First session</span>
                  <strong>{getClubStartDate(club)}</strong>
                </div>
                <div>
                  <span>Venue</span>
                  <strong>{venue}</strong>
                </div>
                <div>
                  <span>Leader / Coach</span>
                  <strong>{getClubCoaches(club) || <em>Not set</em>}</strong>
                </div>
                <div>
                  <span>Member of staff</span>
                  <strong>{getClubMembersOfStaff(club) || <em>Not set</em>}</strong>
                </div>
                <div>
                  <span>Booking</span>
                  <strong>{club.maxParticipants ? `${club.maxParticipants} places` : 'Unlimited places'}</strong>
                </div>
                <div>
                  <span>Payment</span>
                  <strong>{priceType === CLUB_PRICING.FREE ? 'Free' : `£${price} - ${priceType}`}</strong>
                </div>
              </div>
            )}
            {activeTab === CLUB_TABS.PARTICIPANT && (
              <>
                <div className="clubsDsParticipantActions">
                  <button
                    type="button"
                    className="clubsDsBtn clubsDsBtnSecondary"
                    onClick={() => this.runForClub(club, this.onEditParticipantsButtonClick)}
                  >
                    {this.renderDsIcon('users')} Edit participants
                  </button>
                </div>
                {isClubParticipantsLoading ? (
                  <div className="clubsDsDrawerEmpty">
                    <strong>Loading participants…</strong>
                  </div>
                ) : clubParticipants.length > 0 ? (
                  <div className="clubsDsParticipantsList">
                    {clubParticipants.map((participant, index) => {
                      const firstName = propz.get(participant, ['firstName'], '');
                      const lastName = propz.get(participant, ['lastName'], '');
                      const formName = propz.get(participant, ['form', 'name'], 'No form');
                      return (
                        <div
                          className="clubsDsParticipant"
                          key={propz.get(participant, ['id'], `${firstName}-${lastName}-${index}`)}
                        >
                          <span className="clubsDsParticipantNumber">{index + 1}</span>
                          <span className="clubsDsParticipantAvatar">
                            {`${firstName.charAt(0)}${lastName.charAt(0)}` || '?'}
                          </span>
                          <span className="clubsDsParticipantCopy">
                            <strong>{`${firstName} ${lastName}`.trim() || 'Unnamed student'}</strong>
                            <small>{formName}</small>
                          </span>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="clubsDsDrawerEmpty">
                    <span className="clubsDsDrawerEmpty__icon">{this.renderDsIcon('users')}</span>
                    <strong>No participants</strong>
                    <span>No students have been added to this club yet.</span>
                    <button
                      type="button"
                      className="clubsDsBtn clubsDsBtnPrimary"
                      onClick={() => this.runForClub(club, this.onEditParticipantsButtonClick)}
                    >
                      Add participants
                    </button>
                  </div>
                )}
              </>
            )}
            {activeTab === CLUB_TABS.CLUB_EVENTS && (
              <>
                {isActive && (
                  <div className="clubsDsParticipantActions">
                    <button
                      type="button"
                      className="clubsDsBtn clubsDsBtnPrimary"
                      onClick={() => this.runForClub(club, this.onEditEventsButtonClick)}
                    >
                      Manage events
                    </button>
                  </div>
                )}
                {isClubEventsLoading ? (
                  <div className="clubsDsDrawerEmpty">
                    <strong>Loading event summary…</strong>
                  </div>
                ) : (
                  <div className="clubsDsEventsTab">
                    <div className="clubsDsEventStats">
                      <div>
                        <span>Total events</span>
                        <strong>{clubEventSummary.total}</strong>
                      </div>
                      <div className="isUpcoming">
                        <span>Upcoming</span>
                        <strong>{clubEventSummary.upcoming}</strong>
                      </div>
                      <div className="isPast">
                        <span>Past</span>
                        <strong>{clubEventSummary.past}</strong>
                      </div>
                      <div className="isCancelled">
                        <span>Cancelled</span>
                        <strong>{clubEventSummary.cancelled}</strong>
                      </div>
                    </div>
                    <div className="clubsDsEventInsight">
                      <strong>
                        {clubEventSummary.total === 0
                          ? 'No club events yet'
                          : clubEventSummary.upcoming > 0
                          ? `${clubEventSummary.upcoming} upcoming ${
                              clubEventSummary.upcoming === 1 ? 'session' : 'sessions'
                            }`
                          : 'All active sessions are in the past'}
                      </strong>
                      <span>
                        {isActive
                          ? 'Open Manage events to review dates, venues, staff and event status.'
                          : 'Events are generated after the club is activated.'}
                      </span>
                    </div>
                  </div>
                )}
              </>
            )}
            {activeTab === CLUB_TABS.INVITATIONS_AND_BOOKINGS && (
              <div className="clubsDsInvitationsTab">
                <div className="clubsDsInvitationIntro">
                  <div>
                    <strong>Invitation overview</strong>
                    <span>Invitations for this club are sent to {invitationAudienceLabel.toLowerCase()}.</span>
                  </div>
                  <button
                    type="button"
                    className="clubsDsBtn clubsDsBtnPrimary"
                    onClick={() => this.runForClub(club, this.sendInvitationsModalOpen)}
                  >
                    Send invitations
                  </button>
                </div>

                {isClubInvitationSummaryLoading ? (
                  <div className="clubsDsDrawerEmpty">
                    <strong>Loading invitation summary…</strong>
                  </div>
                ) : (
                  <div className="clubsDsInvitationStats">
                    <div>
                      <span>Eligible students</span>
                      <strong>{clubInvitationSummary.eligible}</strong>
                    </div>
                    <div>
                      <span>Invitations sent</span>
                      <strong>{clubInvitationSummary.sent}</strong>
                    </div>
                    <div>
                      <span>Answered</span>
                      <strong>{answeredCount}</strong>
                    </div>
                    <div className="isAccepted">
                      <span>Accepted</span>
                      <strong>{clubInvitationSummary.accepted}</strong>
                    </div>
                    <div className="isRejected">
                      <span>Declined</span>
                      <strong>{clubInvitationSummary.rejected}</strong>
                    </div>
                  </div>
                )}

                <div className="clubsDsInvitationNotice">
                  <strong>Who will receive a new invitation?</strong>
                  <span>
                    Invitations are sent only for eligible students who have an active account and either have not been
                    invited yet or have not responded. Delivery follows the club setting:{' '}
                    {invitationAudienceLabel.toLowerCase()}.
                  </span>
                </div>

                <div className="clubsDsInvitationBookings">
                  <div>
                    <strong>Review booking responses</strong>
                    <span>
                      Open Bookings to see every invitation, its status and last update, who responded, whether the
                      response was changed, and the submitted form answers.
                    </span>
                  </div>
                  <button
                    type="button"
                    className="clubsDsBtn clubsDsBtnSecondary"
                    onClick={() => this.openClubBookings(club)}
                  >
                    View bookings
                  </button>
                </div>
              </div>
            )}
            {activeTab === CLUB_TABS.PAYMENTS && (
              <div className="clubsDsDrawerEmpty">
                <strong>Payments</strong>
                <span>
                  {priceType === CLUB_PRICING.FREE
                    ? 'This club is free.'
                    : 'Payment records are available from the payment summary.'}
                </span>
              </div>
            )}
            {activeTab === CLUB_TABS.PAYMENT_SETTINGS && (
              <div className="clubsDsDetailsGrid">
                <div>
                  <span>Payment required</span>
                  <strong>{propz.get(club, ['paymentSettings', 'askToPay'], false) ? 'Yes' : 'No'}</strong>
                </div>
                <div>
                  <span>Required before booking</span>
                  <strong>{propz.get(club, ['paymentSettings', 'requiredForBook'], false) ? 'Yes' : 'No'}</strong>
                </div>
                <div>
                  <span>Price</span>
                  <strong>{priceType === CLUB_PRICING.FREE ? 'Free' : `£${price}`}</strong>
                </div>
                <div>
                  <span>Pricing model</span>
                  <strong>{priceType}</strong>
                </div>
              </div>
            )}
          </div>

          <div className="clubsDsDrawerFooter">
            {!isActive && (
              <button
                type="button"
                className="clubsDsBtn clubsDsBtnSecondary"
                onClick={() => this.runForClub(club, this.activateClubModalOpen)}
              >
                Activate
              </button>
            )}
            <button
              type="button"
              className="sit-btn sit-btn--primary"
              onClick={() => this.runForClub(club, this.onEditClubWithWizardClick)}
            >
              Edit club
            </button>
          </div>
        </aside>
      </>
    );
  }

  renderDsReportsSelectionModal(): React.ReactNode {
    if (!this.state.isReportsSelectionModalOpen) return null;
    const { selectedItems } = this.state;
    const isOne = selectedItems.length === 1;
    const isNone = selectedItems.length === 0;
    const selectedClubIsAvailable = isOne && selectedItems[0].status !== CLUB_STATUS.DRAFT;
    const isTeacherOrCoach = isUserTeacher(this.props.user) || isUserCoach(this.props.user);
    const reports: Array<{ name: string; description: string; action: () => void }> = [];

    if (isNone && !isTeacherOrCoach) {
      reports.push(
        {
          name: 'Aggregated club participation',
          description: 'Participation totals across clubs for a selected reporting period.',
          action: this.openAggregateClubParticipationReportForm
        },
        {
          name: 'Average club attendance',
          description: 'Average attendance figures across all clubs.',
          action: this.openAverageClubAttendanceReportForm
        },
        {
          name: 'Participation report by students',
          description: 'Student participation across all available clubs.',
          action: this.openClubParticipationByStudentsReportForm
        },
        {
          name: 'Participation statistics by clubs',
          description: 'Compare participation figures and student groups across clubs.',
          action: this.openParticipationByClubsReportForm
        },
        {
          name: 'Attendance statistics by students',
          description: 'Compare attendance figures for students across clubs.',
          action: this.openClubAttendanceByStudentsReportForm
        },
        {
          name: 'Club list by students',
          description: 'Show club membership grouped by student.',
          action: this.openClubListByStudentsReportForm
        },
        {
          name: 'Involvement statistics by students',
          description: 'Analyse student involvement by year and key stage.',
          action: this.openParticipationsByClubsYearGroupsReportForm
        },
        {
          name: 'Weekly club schedule',
          description: 'Generate a weekly timetable of scheduled clubs.',
          action: this.openWeeklyClubScheduleReportForm
        },
        {
          name: 'Club participation by club number',
          description: 'Compare participation grouped by the number of clubs attended.',
          action: this.openClubParticipationByClubNumberReportForm
        }
      );
    }

    if (selectedClubIsAvailable) {
      reports.push({
        name: 'Club attendance',
        description: 'Attendance details for the selected club.',
        action: this.openClubAttendanceReportForm
      });
    }
    if (isOne) {
      if (!isTeacherOrCoach || selectedClubIsAvailable) {
        reports.push({
          name: 'Paper attendance register',
          description: 'A printable attendance register for the selected club.',
          action: this.openPaperAttendanceRegisterClubReportForm
        });
      }
      reports.push({
        name: 'Club booking summary',
        description: 'Booking and capacity information for the selected club.',
        action: this.openClubBookingsReportForm
      });
    }
    if (selectedItems.length > 0 && !isTeacherOrCoach) {
      reports.push({
        name: 'Participation report by students — selected clubs',
        description: 'Student participation limited to the clubs currently selected.',
        action: this.openSelectedClubParticipationByStudentsReportForm
      });
    }
    if (isNone || isTeacherOrCoach) {
      reports.push({
        name: 'Club list for selected date',
        description: 'List the clubs running on a date you choose.',
        action: this.openDateClubsReportForm
      });
    }
    const selectReport = (action: () => void) => this.setState({ isReportsSelectionModalOpen: false }, action);
    return (
      <SimpleModal
        isOpen={true}
        title="Printed forms & reports"
        onCloseClick={() => this.setState({ isReportsSelectionModalOpen: false })}
        showFooter={false}
        isBodyBold={false}
        customClass="clubsModal clubsReportsModal"
      >
        <div className="clubsReportsModal__intro">
          Choose a report. You can configure its contents and format on the next step.
        </div>
        <section className="clubsReportsModal__group">
          <h3>Club reports</h3>
          <div className="clubsReportsModal__list">
            {reports.map(report => (
              <button type="button" key={report.name} onClick={() => selectReport(report.action)}>
                <span className="clubsReportsModal__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M8 13h8M8 17h5" />
                  </svg>
                </span>
                <span className="clubsReportsModal__copy">
                  <span className="clubsReportsModal__heading">
                    <strong>{report.name}</strong>
                    <span className="clubsReportsModal__format">Excel</span>
                  </span>
                  <small>{report.description}</small>
                </span>
                <span className="clubsReportsModal__arrow" aria-hidden="true">
                  ›
                </span>
              </button>
            ))}
          </div>
        </section>
      </SimpleModal>
    );
  }

  renderClubsDsPage(): React.ReactNode {
    const { totalWithFilters, currentPage, isShowFilter, isColumnsMenuOpen, hiddenClubColumnKeys } = this.state;
    const pageCount = Math.max(1, getPagesCount(totalWithFilters, LIMIT));
    const clubs = this.getDisplayedClubs();
    const allColumns = this.getClubDsColumns();
    const visibleColumns = this.getVisibleClubDsColumns();
    const hiddenColumns = new Set(hiddenClubColumnKeys);
    const pageWindowStart = Math.max(1, currentPage - 2);
    const pageWindowEnd = Math.min(pageCount, pageWindowStart + 4);
    const pageNumbers = Array.from(
      { length: pageWindowEnd - pageWindowStart + 1 },
      (_, index) => pageWindowStart + index
    );

    return (
      <div className={`clubsDsPage ${this.state.previewItem ? 'hasDrawer' : ''}`}>
        {this.renderDsReportsSelectionModal()}
        <div className="clubsDsMain">
          <div className="clubsDsHeader">
            <div className="clubsDsHeaderTitle">
              <h1>Clubs</h1>
              <span>{totalWithFilters}</span>
            </div>
            <button type="button" className="clubsDsBtn clubsDsBtnPrimary" onClick={this.onCreateClubClick}>
              {this.renderDsIcon('plus')} Create club
            </button>
          </div>

          <section className="clubsDsContentCard">
            <div className="clubsDsToolbar">
              <div className="clubsDsSearch">
                <input
                  value={String(this.state.filters.name || '')}
                  placeholder="Search by club name…"
                  aria-label="Search by club name"
                  onChange={event => this.onTableFilterChange(event, 'name')}
                  onKeyDown={event => {
                    if (event.key === 'Enter') {
                      event.preventDefault();
                      this.onApplyFilterClick();
                    }
                  }}
                />
              </div>
              <div className="clubsDsFilterAnchor">
                <button
                  type="button"
                  className={`clubsDsIconTextBtn ${isShowFilter ? 'isActive' : ''}`}
                  onClick={this.onTableFilterClick}
                  aria-expanded={isShowFilter}
                >
                  {this.renderDsIcon('filter')} Filters
                </button>
                {isShowFilter ? (
                  <button
                    type="button"
                    className="clubsDsFilterScrim"
                    aria-label="Close filters"
                    onClick={() => {
                      this.setState({ isShowFilter: false });
                      this.setItems();
                    }}
                  />
                ) : null}
                {isShowFilter && this.renderDsFilterPanel()}
              </div>
              <div className="clubsDsColumns">
                <button
                  type="button"
                  className={`clubsDsBtn clubsDsBtnSecondary ${isColumnsMenuOpen ? 'isActive' : ''}`}
                  onClick={() => {
                    const shouldRestoreFilters = this.state.isShowFilter;
                    this.setState(
                      prevState => ({
                        isColumnsMenuOpen: !prevState.isColumnsMenuOpen,
                        isShowFilter: false
                      }),
                      () => {
                        if (shouldRestoreFilters) this.setItems();
                      }
                    );
                  }}
                  aria-expanded={isColumnsMenuOpen}
                >
                  {this.renderDsIcon('columns')} Columns{' '}
                  <span className="clubsDsBtnBadge">{visibleColumns.length}</span>
                </button>
                {isColumnsMenuOpen && (
                  <div className="clubsDsColumnsMenu">
                    <div className="clubsDsColumnsHead">
                      <span>Show / hide columns</span>
                      <button type="button" onClick={this.resetClubColumns}>
                        Reset
                      </button>
                    </div>
                    {allColumns.map(column => {
                      const isVisible = column.locked || !hiddenColumns.has(column.field);
                      return (
                        <label key={column.field} className={`clubsDsColumnsItem ${column.locked ? 'isLocked' : ''}`}>
                          <input
                            type="checkbox"
                            checked={isVisible}
                            disabled={column.locked}
                            onChange={() => this.toggleClubColumn(column.field)}
                          />
                          <span>{column.text}</span>
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
              <div className="clubsDsMenu">
                <button
                  type="button"
                  className="clubsDsBtn clubsDsBtnSecondary"
                  onClick={() => this.setState({ isReportsSelectionModalOpen: true })}
                >
                  {this.renderDsIcon('reports')} Reports
                </button>
              </div>
            </div>

            {this.renderDsActiveFilterChips()}
            {this.renderClubSelectionBar()}
            {this.renderClubTable()}

            <div className="clubsDsFooter">
              <span className="clubsDsPaginationSummary">
                Page {currentPage} of {pageCount}
              </span>
              <button
                type="button"
                className="clubsDsPagerBtn"
                disabled={currentPage <= 1}
                onClick={() => this.setCurrentPageParams(currentPage - 1)}
              >
                Previous
              </button>
              {pageWindowStart > 1 && (
                <>
                  <button type="button" className="clubsDsPageBtn" onClick={() => this.setCurrentPageParams(1)}>
                    1
                  </button>
                  {pageWindowStart > 2 && <span className="clubsDsPaginationEllipsis">...</span>}
                </>
              )}
              {pageNumbers.map(pageNumber => (
                <button
                  key={pageNumber}
                  type="button"
                  className={`clubsDsPageBtn ${pageNumber === currentPage ? 'isActive' : ''}`}
                  onClick={() => this.setCurrentPageParams(pageNumber)}
                >
                  {pageNumber}
                </button>
              ))}
              {pageWindowEnd < pageCount && (
                <>
                  {pageWindowEnd < pageCount - 1 && <span className="clubsDsPaginationEllipsis">...</span>}
                  <button type="button" className="clubsDsPageBtn" onClick={() => this.setCurrentPageParams(pageCount)}>
                    {pageCount}
                  </button>
                </>
              )}
              <button
                type="button"
                className="clubsDsPagerBtn"
                disabled={currentPage >= pageCount}
                onClick={() => this.setCurrentPageParams(currentPage + 1)}
              >
                Next
              </button>
            </div>
          </section>
        </div>
        {this.renderClubDrawer()}
      </div>
    );
  }
  renderDsFilterPanel(): React.ReactNode {
    const { forms } = this.state;
    const { user } = this.props;
    const ageGroupName = propz.get(user, ['activeSchool', 'ageGroupsNaming'], '');
    const filterOptions = {
      status: getSelectOptionForClubStatus(),
      clubAges: getSelectOptionForAge(forms, ageGroupName),
      gender: getSelectOptionForClubGender(),
      clubAcademicYear: getSelectOptionForClubAcademicYears(),
      clubWeekDays: getSelectOptionForClubWeekDays(),
      clubRecurrence: getSelectOptionForClubRecurrence()
    };

    const getOptionLabel = option => option.text || option.label || option.value;

    const renderSelect = (field: string, label: string) => {
      const rawValue = this.state.filters[field];
      const selectedValue = Array.isArray(rawValue) ? rawValue[0] || '' : rawValue || '';
      return (
        <label className="clubsDsFilterField">
          <span>{label}</span>
          <select
            value={selectedValue}
            onChange={event => this.setDsSingleFilterValue(field, event.target.value)}
            onKeyDown={event => {
              if (event.key === 'Enter') {
                this.onApplyFilterClick();
              }
            }}
          >
            <option value="">All</option>
            {(filterOptions[field] || []).map(option => (
              <option key={String(option.value)} value={String(option.value)}>
                {getOptionLabel(option)}
              </option>
            ))}
          </select>
        </label>
      );
    };

    const renderMultiChips = (field: string, label: string) => {
      const selectedValues = this.getDsFilterValues(field);
      const options = filterOptions[field] || [];
      return (
        <div className="clubsDsFilterField clubsDsFilterFieldWide">
          <span>{label}</span>
          <div className="clubsDsFilterChips" role="group" aria-label={label}>
            {options.map(option => {
              const value = String(option.value);
              const isSelected = selectedValues.includes(value);
              return (
                <button
                  key={value}
                  type="button"
                  className={`clubsDsFilterChip ${isSelected ? 'isSelected' : ''}`}
                  onClick={() => this.toggleDsFilterValue(field, value)}
                >
                  {getOptionLabel(option)}
                </button>
              );
            })}
          </div>
        </div>
      );
    };

    const renderDateRange = (field: string, label: string) => {
      const value = this.state.filters[field] || {};
      const range = {
        start: this.getDsDateFilterDate(value.from || ''),
        end: this.getDsDateFilterDate(value.to || '')
      };

      return (
        <div className="clubsDsFilterField clubsDsFilterFieldWide clubsDsDateRange">
          <SitDatePicker
            label={label}
            mode="range"
            value={range}
            onChange={nextValue => this.setDsDateRangeFilterValue(field, nextValue)}
            format="DD-MM-YYYY"
            placeholder="Select date range"
            numberOfMonths={2}
            align="left"
            clearable={true}
            syncRangeOnSelect={true}
          />
        </div>
      );
    };

    return (
      <div className="clubsDsFilters">
        <div className="clubsDsFilterHead">
          <strong>Filters</strong>
          <button
            type="button"
            className="clubsDsFilterClose"
            aria-label="Close filters"
            onClick={() => {
              this.setState({ isShowFilter: false });
              this.setItems();
            }}
          >
            ×
          </button>
        </div>
        <div className="clubsDsFilterBody">
          {renderMultiChips('status', 'Status')}
          {renderSelect('clubAcademicYear', 'Academic year')}
          {renderDateRange('clubStartDate', 'Start date')}
          {renderMultiChips('gender', 'Gender')}
          {renderMultiChips('clubAges', 'Ages')}
          {renderMultiChips('clubWeekDays', 'Week day')}
          {renderMultiChips('clubRecurrence', 'Recurrence')}
        </div>
        <div className="clubsDsFilterActions">
          <button type="button" className="clubsDsBtn clubsDsBtnGhost is-clear" onClick={this.onClearFilterClick}>
            Clear all
          </button>
          <div>
            <button
              type="button"
              className="clubsDsBtn clubsDsBtnGhost"
              onClick={() => {
                this.setState({ isShowFilter: false });
                this.setItems();
              }}
            >
              Cancel
            </button>
            <button type="button" className="clubsDsBtn clubsDsBtnPrimary is-apply" onClick={this.onApplyFilterClick}>
              Apply
            </button>
          </div>
        </div>
      </div>
    );
  }
  renderGrid() {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      forms,
      isSelectAllChecked,
      currentPage,
      totalWithFilters
    } = this.state;

    const { user } = this.props;

    const ageGroupName = propz.get(user, ['activeSchool', 'ageGroupsNaming'], '');

    const isActiveShowClubAttendanceReportButton =
      selectedItems.length === 1 && selectedItems[0].status !== CLUB_STATUS.DRAFT;

    const isActiveShowPaperAttendanceRegisterClubReportButton =
      selectedItems.length === 1 && selectedItems[0].status !== CLUB_STATUS.DRAFT;

    const isActiveShowClubBookingsReportButton = selectedItems.length === 1;

    const isUserTeacherOrCoach = isUserTeacher(user) || isUserCoach(user);

    const actionItems = [
      {
        itemText: 'Create club',
        onItemClick: this.onCreateClubClick,
        isActive: selectedItems.length === 0
      },
      {
        itemText: 'Create like this (settings only)',
        onItemClick: () => this.onCopyClubWithWizardClick(MODE_TYPE.CLUB_COPY),
        isActive: selectedItems.length === 1
      },
      {
        itemText: 'Create like this (settings + participants)',
        onItemClick: () => this.onCopyClubWithWizardClick(MODE_TYPE.CLUB_COPY_WITH_PARTICIPANTS),
        isActive: selectedItems.length === 1
      },
      {
        itemText: 'Edit club',
        onItemClick: this.onEditClubWithWizardClick,
        isActive: selectedItems.length === 1
      },
      {
        itemText: selectedItems.length === 1 ? 'Delete club' : 'Delete clubs',
        onItemClick: this.deleteClubModalOpen,
        isActive: this.isDeleteClubStatusDraft()
      },
      {
        itemText: selectedItems.length === 1 ? 'Activate club' : 'Activate clubs',
        onItemClick: this.activateClubModalOpen,
        isActive: this.isActivateClubAndSendInvitationsActive()
      },
      {
        itemText: 'Send invitations',
        onItemClick: this.sendInvitationsModalOpen,
        isActive: this.isActivateClubAndSendInvitationsActive()
      },
      {
        itemText: 'Reports',
        isActive: true,
        subItems: isUserTeacherOrCoach
          ? [
              {
                itemText: 'Selected club attendance register',
                onItemClick: this.openClubAttendanceReportForm,
                isActive: isActiveShowClubAttendanceReportButton
              },
              {
                itemText: 'Printable attendance register',
                onItemClick: this.openPaperAttendanceRegisterClubReportForm,
                isActive: isActiveShowPaperAttendanceRegisterClubReportButton
              },
              {
                itemText: 'Club booking summary',
                onItemClick: this.openClubBookingsReportForm,
                isActive: isActiveShowClubBookingsReportButton
              },
              {
                itemText: 'Clubs running on a selected date',
                onItemClick: this.openDateClubsReportForm,
                isActive: true
              }
            ]
          : [
              {
                itemText: 'Club participation summary by student group',
                onItemClick: this.openAggregateClubParticipationReportForm,
                isActive: selectedItems.length == 0
              },
              {
                itemText: 'Selected club attendance register',
                onItemClick: this.openClubAttendanceReportForm,
                isActive: isActiveShowClubAttendanceReportButton
              },
              {
                itemText: 'Printable attendance register',
                onItemClick: this.openPaperAttendanceRegisterClubReportForm,
                isActive: selectedItems.length == 1
              },
              {
                itemText: 'Average attendance by club',
                onItemClick: this.openAverageClubAttendanceReportForm,
                isActive: selectedItems.length == 0
              },
              {
                itemText: 'Student club participation',
                onItemClick: this.openClubParticipationByStudentsReportForm,
                isActive: selectedItems.length == 0
              },
              {
                itemText: 'Student participation in selected clubs',
                onItemClick: this.openSelectedClubParticipationByStudentsReportForm,
                isActive: selectedItems.length > 0
              },
              {
                itemText: 'Participation totals by club',
                onItemClick: this.openParticipationByClubsReportForm,
                isActive: selectedItems.length == 0
              },
              {
                itemText: 'Student attendance across clubs',
                onItemClick: this.openClubAttendanceByStudentsReportForm,
                isActive: selectedItems.length == 0
              },
              {
                itemText: 'Student club memberships',
                onItemClick: this.openClubListByStudentsReportForm,
                isActive: selectedItems.length == 0
              },
              {
                itemText: 'Club participation by year group',
                onItemClick: this.openParticipationsByClubsYearGroupsReportForm,
                isActive: selectedItems.length == 0
              },
              {
                itemText: 'Club booking summary',
                onItemClick: this.openClubBookingsReportForm,
                isActive: isActiveShowClubBookingsReportButton
              },

              {
                itemText: 'Weekly club timetable',
                onItemClick: this.openWeeklyClubScheduleReportForm,
                isActive: selectedItems.length == 0
              },

              {
                itemText: 'Clubs running on a selected date',
                onItemClick: this.openDateClubsReportForm,
                isActive: selectedItems.length == 0
              },
              {
                itemText: 'Students by number of clubs attended',
                onItemClick: this.openClubParticipationByClubNumberReportForm,
                isActive: selectedItems.length == 0
              }
            ]
      },
      {
        itemText: selectedItems.length === 1 ? 'Archive club' : 'Archive clubs',
        onItemClick: this.onArchiveClubClick,
        isActive: selectedItems.length > 0 && selectedItems.every(club => club.status === CLUB_STATUS.ACTIVE)
      }
    ];

    const filterOptions = {
      status: getSelectOptionForClubStatus(),
      clubAges: getSelectOptionForAge(forms, ageGroupName),
      gender: getSelectOptionForClubGender(),
      clubAcademicYear: getSelectOptionForClubAcademicYears(),
      clubWeekDays: getSelectOptionForClubWeekDays(),
      clubRecurrence: getSelectOptionForClubRecurrence()
    };

    return (
      <Grid2
        user={user}
        dataItems={items}
        filters={filters}
        currentPage={currentPage}
        total={totalWithFilters}
        isSelectAllChecked={isSelectAllChecked}
        isDataFiltered={isDataFiltered}
        sortDirection={sortDirection}
        sortColumnsName={sortColumnsName}
        isShowFilter={isShowFilter}
        dataItemsSelected={selectedItems}
        columns={COLUMNS}
        emptyText="No clubs yet"
        emptyHint="Create a club to manage its schedule, participants, bookings and attendance."
        emptyFilteredText="No clubs match your filters"
        emptyFilteredHint="Try changing or clearing the search and filters to see other clubs."
        emptyIcon={faRunning}
        actionItems={actionItems}
        options={filterOptions}
        onItemClick={this.onItemClick}
        onSortClick={this.onTableSortClick}
        onApplyFilterClick={this.onApplyFilterClick}
        onClearFilterClick={this.onClearFilterClick}
        onTableFilterChange={this.onTableFilterChange}
        onTableFilterClick={this.onTableFilterClick}
        setCurrentPageParams={this.setCurrentPageParams}
        onSelectAllClick={this.onSelectAllClick}
        onSelectAllOnPageClick={this.onSelectAllOnPageClick}
        onUnselectAllClick={this.onUnselectAllClick}
      />
    );
  }

  requestInvitationFlowExit = (hasUnsavedChanges: boolean = true) => {
    if (!hasUnsavedChanges) {
      this.onCloseConfirmationRequestTemplateModalClick();
      return;
    }
    this.setState({ isInvitationExitConfirmOpen: true });
  };

  onCloseConfirmationRequestTemplateModalClick = () => {
    this.setState({
      isConfirmationRequestTemplateModalOpen: false,
      isSendInvitationsModalOpen: false,
      isInvitationExitConfirmOpen: false,
      invitationFlowStep: 'FORM',
      invitationRecipients: [],
      invitationUseAllEligible: false,
      invitationRecipientCount: 0,
      allClubsStudents: [],
      fields: [],
      selectedFormDefinition: undefined,
      deadlineForAnswers: '',
      deadlineForAnswersDate: null,
      isDeadlineForAnswersError: false
    });
    if (this.isSendClubInvitationsPageOpen()) this.closeSendClubInvitationsPage();
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb', { detail: 'Clubs / Clubs' }));
  };

  renderInvitationExitConfirmModal = () => (
    <SimpleModal
      isOpen={this.state.isInvitationExitConfirmOpen}
      title="Leave invitations?"
      buttonText="Back to clubs"
      buttonCancelText="Continue editing"
      onButtonClick={this.onCloseConfirmationRequestTemplateModalClick}
      onCloseClick={() => this.setState({ isInvitationExitConfirmOpen: false })}
      customClass="clubsModal clubsInvitationExitModal"
      dialogStyle={{ maxWidth: 520 }}
      isBodyBold={false}
      zIndex={1070}
    >
      <div className="clubsInvitationExitModal__body">
        <div className="clubsInvitationExitModal__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M12 8v5" />
            <path d="M12 17h.01" />
            <path d="M10.3 3.9 2.4 17.6A2 2 0 0 0 4.1 20h15.8a2 2 0 0 0 1.7-2.4L13.7 3.9a2 2 0 0 0-3.4 0Z" />
          </svg>
        </div>
        <div className="clubsInvitationExitModal__copy">
          <strong>Invitations have not been sent</strong>
          <p>Returning to clubs will discard the selected recipients and any booking form changes made in this flow.</p>
        </div>
      </div>
    </SimpleModal>
  );

  closeInvitationSuccessModal = () => {
    this.setState({
      isInvitationSuccessModalOpen: false,
      successfulInvitationsCount: 0,
      successfulClubsCount: 0,
      selectedItems: [],
      isSelectAllChecked: false
    });
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb', { detail: 'Clubs / Clubs' }));
  };

  renderInvitationSuccessModal = (): React.ReactNode => {
    const { isInvitationSuccessModalOpen, successfulInvitationsCount, successfulClubsCount } = this.state;
    const message =
      successfulInvitationsCount === 0
        ? 'The invitation update completed successfully. No new notifications were required.'
        : successfulInvitationsCount === 1
        ? '1 invitation was sent successfully.'
        : `${successfulInvitationsCount} invitations were sent successfully.`;

    return (
      <SimpleModal
        isOpen={isInvitationSuccessModalOpen}
        title="Invitations sent"
        onCloseClick={this.closeInvitationSuccessModal}
        onBackdropClick={this.closeInvitationSuccessModal}
        showFooter={false}
        isBodyBold={false}
        customClass="clubsModal clubsInvitationSuccessModal"
        bodyClassName="clubsModalBody"
        dialogStyle={{ maxWidth: 460 }}
        zIndex={1060}
      >
        <div className="clubsModalContent">
          <div className="clubsModalLead isSuccess">
            <span className="clubsModalLeadIcon" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="8.5" />
                <path d="m8.5 12 2.25 2.25L15.75 9" />
              </svg>
            </span>
            <div>
              <strong>Invitation delivery completed</strong>
              <p>{message}</p>
              {successfulClubsCount > 1 && <p>Invitations were processed for {successfulClubsCount} clubs.</p>}
            </div>
          </div>
          <div className="clubsModalActions isEnd">
            <button type="button" className="clubsModalButton isPrimary" onClick={this.closeInvitationSuccessModal}>
              Done
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  };

  onNextClick = (fields, deadlineForAnswers, formDefinition?: FormDefinition) => {
    const raw = (deadlineForAnswers || '').trim();
    const m = raw ? moment(raw, INPUT_MASK_VALIDATION, true) : null;

    this.closeSendClubInvitationsPage();
    this.setState({
      isConfirmationRequestTemplateModalOpen: false,
      isSendInvitationsModalOpen: true,
      fields,
      selectedFormDefinition: formDefinition || undefined,
      deadlineForAnswers: raw,
      deadlineForAnswersDate: m && m.isValid() ? m.toDate() : null,
      isDeadlineForAnswersError: false,
      previewItem: undefined,
      allClubsStudents: this.state.invitationUseAllEligible
        ? this.state.selectedItems.map(() => [])
        : [this.state.invitationRecipients]
    });
  };

  onCloseErrorClick = () => {
    this.setState({
      isErrorModalOpen: false,
      errorMessage: ''
    });
  };

  renderSendingError(): React.ReactNode {
    const { errorMessage, isErrorModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isErrorModalOpen}
        title="Something went wrong"
        onCloseClick={this.onCloseErrorClick}
        showFooter={false}
        isBodyBold={false}
        customClass="clubsModal clubsErrorModal"
        bodyClassName="clubsModalBody"
        dialogStyle={{ maxWidth: 460 }}
      >
        <div className="clubsModalContent">
          <div className="clubsModalLead isDanger">
            <span className="clubsModalLeadIcon" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="8.5" />
                <path d="M12 7.75v5" />
                <path d="M12 16.25h.01" />
              </svg>
            </span>
            <div>
              <strong>The action could not be completed</strong>
              <p>{errorMessage || 'Please try again.'}</p>
            </div>
          </div>
          <div className="clubsModalActions">
            <button type="button" className="clubsModalButton isPrimary" onClick={this.onCloseErrorClick}>
              OK
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  }

  renderConfirmationRequestTemplateModal() {
    const { isConfirmationRequestTemplateModalOpen } = this.state;

    if (!this.isPaidClubSelection()) {
      return null;
    }

    return (
      <SimpleModal
        customClass="clubsModal clubsInfoModal mClubSendMessagesFormWidth"
        isOpen={isConfirmationRequestTemplateModalOpen}
        title="Paid club invitations are unavailable"
        onCloseClick={this.onCloseConfirmationRequestTemplateModalClick}
        showFooter={false}
        isBodyBold={false}
        bodyClassName="clubsModalBody"
        dialogStyle={{ maxWidth: 480 }}
      >
        <div className="clubsModalContent">
          <div className="clubsModalLead isInfo">
            <span className="clubsModalLeadIcon" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="8.5" />
                <path d="M12 10.5v5" />
                <path d="M12 7.5h.01" />
              </svg>
            </span>
            <div>
              <strong>Student invitations for paid clubs are not included</strong>
              <p>Contact the Squad In Touch support team to discuss enabling this feature for your school.</p>
            </div>
          </div>
          <div className="clubsModalActions">
            <button
              type="button"
              className="clubsModalButton isPrimary"
              onClick={this.onCloseConfirmationRequestTemplateModalClick}
            >
              OK
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  }

  renderConfirmationRequestTemplatePage() {
    const {
      confirmationRequestTemplate,
      invitationFlowStep,
      selectedItems,
      clubInvitationSummary,
      isClubInvitationSummaryLoading
    } = this.state;

    if (!this.isSendClubInvitationsPageOpen()) {
      return null;
    }

    if (invitationFlowStep === 'RECIPIENTS' && selectedItems.length === 1) {
      return (
        <ClubInvitationRecipientsStep
          user={this.props.user}
          club={selectedItems[0]}
          invitationSummary={clubInvitationSummary}
          isInvitationSummaryLoading={isClubInvitationSummaryLoading}
          onBack={this.requestInvitationFlowExit}
          onNext={(students, useAllEligible, recipientCount) =>
            this.setState(
              {
                invitationRecipients: students,
                invitationUseAllEligible: useAllEligible,
                invitationRecipientCount: recipientCount,
                invitationFlowStep: 'FORM'
              },
              () =>
                window.dispatchEvent(
                  new CustomEvent('sit:topbar-breadcrumb', {
                    detail: `Clubs / ${selectedItems[0].name} / Booking form`
                  })
                )
            )
          }
        />
      );
    }

    if (invitationFlowStep === 'MULTI_WARNING') {
      return (
        <SendRequestPageShell
          title="Send invitations"
          subtitle={`${selectedItems.length} clubs selected`}
          onBack={() => this.requestInvitationFlowExit(false)}
          backLabel="Back to clubs"
          className="SendRequestPageShell--clubTransfer"
        >
          <div className="clubsInviteMultiWarning">
            <div className="clubsInviteMultiWarning__banner">
              <span aria-hidden="true">!</span>
              <div>
                <strong>Invitations will be sent separately for every selected club</strong>
                <p>
                  Each club will send its own booking invitation to all students eligible for that club. Recipient
                  selection is not available when several clubs are selected.
                </p>
              </div>
            </div>
            <div className="clubsInviteMultiWarning__clubs">
              {selectedItems.map(club => (
                <div key={club.id}>
                  <strong>{club.name}</strong>
                  <span>{propz.get(club, ['sport', 'name'], 'Activity not set')}</span>
                </div>
              ))}
            </div>
            <div className="clubsInviteMultiWarning__actions">
              <button
                type="button"
                className="sit-btn sit-btn--secondary"
                onClick={() => this.requestInvitationFlowExit(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="sit-btn sit-btn--primary"
                onClick={() =>
                  this.setState({ invitationUseAllEligible: true, invitationFlowStep: 'FORM' }, () =>
                    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb', { detail: 'Clubs / Booking form' }))
                  )
                }
              >
                Continue to booking form
              </button>
            </div>
          </div>
        </SendRequestPageShell>
      );
    }

    return (
      <SendRequestPageShell
        title="Booking form"
        subtitle="Review the questions that parents or students will receive and answer when booking this club."
        onBack={this.requestInvitationFlowExit}
        backLabel="Back to clubs"
        className="SendRequestPageShell--clubTransfer"
      >
        <ConfirmationRequestForm
          templateType="CLUB_BOOKING"
          user={this.props.user}
          template={confirmationRequestTemplate}
          onCancelClick={this.requestInvitationFlowExit}
          onSendConfirmationRequestsClick={this.onNextClick}
          textSubmitButton={'Next'}
          isRenderDeadline={true}
          inviteKind={INVITE_KIND.CLUB_SCHOOL_INVITE as INVITE_KIND_TYPE}
          defaultBuilderMode="COMPACT"
          customClassName="clubBookingForm"
        />
      </SendRequestPageShell>
    );
  }
  onUpdatePaymentSettings = (data: any) => {
    const { user } = this.props;
    const { selectedItems, items } = this.state;
    const club = selectedItems[0];

    updateClub(user, data, club.id).then(clubUpdated => {
      const index = items.findIndex(item => item.id === clubUpdated.id);
      const itemsUpdated = [...items];
      itemsUpdated[index] = club;

      this.setState({
        items: itemsUpdated,
        selectedItems: [clubUpdated]
      });
    });
  };
  render() {
    const {
      isLoading,
      isDeleteClubModalOpen,
      isActivateClubModalOpen,
      isSendInvitationsModalOpen,
      isConfirmationRequestTemplateModalOpen,
      isAggregateClubParticipationReportModalOpen,
      isClubAttendanceReportModalOpen,
      isClubParticipationByStudentsReportModalOpen,
      isClubListByStudentsReportModalOpen,
      isErrorModalOpen,
      isArchiveClubsModalOpen,
      isParticipationByClubsReportModalOpen,
      isClubAttendanceByStudentsReportModalOpen,
      isParticipationsByClubsYearGroupsReportModalOpen,
      isClubBookingsReportModalOpen,
      isWeeklyClubScheduleReportModalOpen,
      isDateClubsReportModalOpen,
      isClubParticipationByCLubNumberReportModalOpen,
      isAverageClubAttendanceReportModalOpen,
      isPaperAttendanceRegisterClubReportModalOpen,
      isCreateClubsDisabledModalOpen,
      isReportsSelectionModalOpen,
      isInvitationExitConfirmOpen,
      isInvitationSuccessModalOpen
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    if (this.isSendClubInvitationsPageOpen()) {
      return (
        <>
          {this.renderConfirmationRequestTemplatePage()}
          {this.renderInvitationExitConfirmModal()}
        </>
      );
    }

    const classes =
      isDeleteClubModalOpen ||
      isActivateClubModalOpen ||
      isSendInvitationsModalOpen ||
      (isConfirmationRequestTemplateModalOpen && this.isPaidClubSelection()) ||
      isArchiveClubsModalOpen ||
      isErrorModalOpen ||
      isAggregateClubParticipationReportModalOpen ||
      isClubAttendanceReportModalOpen ||
      isParticipationByClubsReportModalOpen ||
      isClubParticipationByStudentsReportModalOpen ||
      isClubListByStudentsReportModalOpen ||
      isClubAttendanceByStudentsReportModalOpen ||
      isParticipationsByClubsYearGroupsReportModalOpen ||
      isClubBookingsReportModalOpen ||
      isWeeklyClubScheduleReportModalOpen ||
      isDateClubsReportModalOpen ||
      isClubParticipationByCLubNumberReportModalOpen ||
      isAverageClubAttendanceReportModalOpen ||
      isPaperAttendanceRegisterClubReportModalOpen ||
      isCreateClubsDisabledModalOpen ||
      isReportsSelectionModalOpen ||
      isInvitationExitConfirmOpen ||
      isInvitationSuccessModalOpen
        ? 'clubsRoute modal-open'
        : 'clubsRoute';

    return (
      <div className={classes}>
        {/*Place for render modal windows*/}
        {this.renderDeleteClubModal()}
        {this.renderActivateClubModal()}
        {this.renderSendInvitationsClubModal()}
        {this.renderInvitationExitConfirmModal()}
        {this.renderInvitationSuccessModal()}
        {this.renderConfirmationRequestTemplateModal()}
        {this.renderAggregateClubParticipationReportFormModal()}
        {this.renderClubAttendanceReportFormModal()}
        {this.renderClubParticipationByStudentsReportFormModal()}
        {this.renderParticipationsByClubsReportFormModal()}
        {this.renderClubAttendancesByStudentsReportFormModal()}
        {this.renderClubListByStudentsReportFormModal()}
        {this.renderParticipationsByClubsYearGroupsReportFormModal()}
        {this.renderClubBookingsReportFormModal()}
        {this.renderWeeklyClubScheduleReportFormModal()}
        {this.renderDateClubsReportFormModal()}
        {this.renderSendingError()}
        {this.renderArchiveClubsModal()}
        {this.renderCreateClubsDisabledModal()}
        {this.renderSelectedClubParticipationByStudentsReportFormModal()}
        {this.renderClubParticipationByClubNumberReportFormModal()}
        {this.renderAverageClubAttendanceReportFormModal()}
        {this.renderPaperAttendanceRegisterClubReportFormModal()}
        {this.renderClubsDsPage()}
      </div>
    );
  }
}
